import { LOCALES } from "../constants";

const no = {
  [LOCALES.NO]: {
    //All page
    "Página não encontrada": "Siden ble ikke funnet",
    //LOGIN PAGE
    "login.Login": "Logg inn",
    "login.Informe seu e-mail": "Oppgi e-postadressen din",
    "login.E-mail inválido. Por favor, verifique":
    "Ugyldig e-postadresse. Vennligst kontroller den",
    "login.Senha": "Passord",
    "login.Sua senha deve possuir no mínimo 6 caracteres":
    "Passordet må inneholde minst 6 tegn",
    "login.Esqueci minha senha": "Jeg har glemt passordet mitt",
    "login.ENTRAR": "LOGG INN",
    "login.CRIAR CONTA": "OPPRETT KONTO",
    "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente":
    "Kunne ikke logge inn. Kontroller opplysningene dine og prøv igjen",
    "login.A PLATAFORMA IOK MUDOU!": "IOK-PLATTFORMEN HAR ENDRET SEG!",
    "login.Não exibir este aviso novamente": "Ikke vis denne meldingen igjen",
    "login.Se você já possui um cadastro na antiga plataforma, ": "Hvis du allerede har en konto på den gamle plattformen, ",
    "login.clique aqui": "klikk her",
    "login. para": " for å ",
    "login.migrar": "migrere ",
    "login.seus dados e aproveitar toda a experiência IOK.": "dataene dine og få full glede av IOK-opplevelsen.",
    "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "Kontoen din er ikke aktivert. Vennligst sjekk e-posten din for å aktivere den",
    "login.PLATAFORMA EM MANUTENÇÃO": "PLATTFORMEN ER UNDER VEDLIKEHOLD",
    "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "VI FORBEREDER DEN NYE IOK-PLATTFORMEN, OG DEN VIL SNART VÆRE KLAR!",
    "login.Migrar Conta": "Migrer konto",
    "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "Hvis du allerede har en konto på den gamle plattformen, klikker du på Migrer konto for å migrere dataene dine og få full glede av IOK-opplevelsen",
    "login.Política de privacidade": "Personvernerklæring",
    "login.ENTENDI": "JEG FORSTÅR",
    "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "For å forbedre opplevelsen din på plattformen og tilby tilpassede tjenester bruker vi informasjonskapsler.",
    "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "Ved å bruke IOK-plattformen samtykker du automatisk til bruken av dem.",
    "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "Feil passord! Du har to forsøk igjen før kontoen blir låst.",
    "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "Feil passord! Du har ett forsøk igjen før kontoen blir låst.",
    "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "Tilgangen er låst! Følg instruksjonene for kontogjenoppretting.",
    
    // REGISTER
    "DISTRIBUIDOR": "DISTRIBUTØR:Jeg er distributør av Prática-utstyr.",
    "REDE": "KJEDE:Jeg eier en kjede.",
    "DONO": "SELSKAP:Jeg eier mitt eget selskap / er en del av en kjede.",
    "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Oppgi e-postadressen som var registrert på den tidligere IOK-plattformen",
    "register.E-mail inválido. Por favor, verifique": "Ugyldig e-postadresse. Vennligst kontroller den",
    "register.BUSCAR DADOS": "HENT DATA",
    "register.Nome da organização": "Organisasjonsnavn",
    "register.Informe o nome de sua organização": "Oppgi navnet på organisasjonen din",
    "register.O campo nome da organização é obrigatório": "Feltet organisasjonsnavn er obligatorisk",
    "register.Este nome já existe. Por favor, escolha outro": "Dette navnet finnes allerede. Velg et annet",
    "register.RECUPERAR CONTA": "GJENOPPRETT KONTO",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA DE USUÁRIO. POR GENTILIZA, AGUARDE": "ORGANISASJONENS ADMINISTRATOR VIL MOTTA EN E-POST FOR Å AKTIVERE BRUKERKONTOEN DIN. VENNLIGST VENT.",
    "register.E-mail não encontrado": "Fant ikke e-postadressen",
    "register.Digite seu e-mail da plataforma IOK antiga": "Skriv inn e-postadressen din fra den gamle IOK-plattformen",
    "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "Kunne ikke gjenopprette kontoen din. Kontroller opplysningene dine og prøv igjen",
    "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "Kunne ikke hente dataene dine. Kontroller dem og prøv igjen",
    "register.PROSSEGUIR": "FORTSETT",
    "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO:": "DU BER OM TILGANG TIL ORGANISASJONEN: ",
    "register.COM O ADMINISTRADOR:": " MED ADMINISTRATOREN: ",
    "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "E-postadressen er allerede registrert på plattformen. Oppgi en ny e-postadresse eller logg inn med den registrerte e-postadressen",
    "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "Selskapet er allerede registrert på plattformen. Oppgi navnet på et nytt selskap",
    "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "DU GJENKJENTE IKKE BRUKEREN {userName} SOM EN DEL AV ORGANISASJONEN DIN, OG DERFOR BLE KONTOEN SLETTET.",
    "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "KUNNE IKKE SLETTE BRUKEREN {userName}. VENNLIGST PRØV IGJEN SENERE.",
    "register.CONFIRMAR": "BEKREFT",
    "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente":
    "Kunne ikke fullføre registreringen. Kontroller opplysningene dine og prøv igjen",
    "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR":
    "DU VIL MOTTA EN E-POST FOR Å FULLFØRE REGISTRERINGEN OG AKTIVERE ADMINISTRATORKONTOEN DIN",
    "register.Nome": "Navn",
    "register.Informe seu nome": "Oppgi navnet ditt",
    "register.O campo nome é obrigatório": "Navnefeltet er obligatorisk",
    "register.E-mail": "E-post",
    "register.Informe seu e-mail": "Oppgi e-postadressen din",
    "register.E-mail inválido. Por favor, verifique novamente":
    "Ugyldig e-postadresse. Vennligst kontroller den på nytt",
    "register.Telefone": "Telefon",
    "register.Informe seu telefone": "Oppgi telefonnummeret ditt",
    "register.Crie sua senha": "Opprett passordet ditt",
    "register.Informe sua senha": "Oppgi passordet ditt",
    "register.O campo senha deve conter no mínimo 6 caracteres":
    "Passordfeltet må inneholde minst 6 tegn",
    "register.Confirme sua senha": "Bekreft passordet ditt",
    "register.As senhas devem ser iguais": "Passordene må være identiske",
    "register.CRIAR CONTA": "OPPRETT KONTO",
    "register.CONTA ATIVADA COM SUCESSO": "KONTOEN ER AKTIVERT",
    "register.ACESSAR": "ÅPNE",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA":
    "KUNNE IKKE AKTIVERE KONTOEN DIN",
    "register.Digite seu telefone": "Skriv inn telefonnummeret ditt",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "VENT MENS VI OVERFØRER DATAENE DINE. DENNE PROSESSEN TAR VANLIGVIS NOEN MINUTTER. HVIS DU HAR EN STOR MENGDE DATA, KAN OVERFØRINGEN TA OPPTIL ÉN TIME.",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "DATAENE ER OVERFØRT. KLIKK PÅ KNAPPEN NEDENFOR FOR Å GÅ TIL PLATTFORMEN.",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "UGYLDIG E-POSTADRESSE. VENNLIGST KONTROLLER AT KONTOEN DIN ER AKTIVERT.",
    "register.Ainda não tenho uma organização. Criar": "Jeg har ennå ingen organisasjon. Opprett",
    "register.Informe o ID da organização": "Oppgi organisasjonens ID",
    "register.O campo com ID é obrigatório": "ID-feltet er obligatorisk",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "ORGANISASJONENS ADMINISTRATOR VIL MOTTA EN E-POST FOR Å AKTIVERE KONTOEN DIN. VENNLIGST VENT.",
    "register.A nova plataforma IOK agora está dividida em organizações e possui diferentes tipos de conta, que ajudam a organizar melhor as grandes corporações, empresas e redes.": "Den nye IOK-plattformen er nå delt inn i organisasjoner og har ulike kontotyper som gjør det enklere å organisere store konsern, selskaper og kjeder.",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "Administratoren i organisasjonen min har allerede migrert kontoen, og vi har en ID. Jeg ønsker å migrere brukerdataene mine.",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "Jeg ønsker å migrere organisasjonens konto og bli administrator.",
    "register.Conta da organização já migrada": "Organisasjonens konto er allerede migrert",
    "register.Migrar conta da organização": "Migrer organisasjonens konto",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "Den nye IOK-plattformen har nå nye tilgangsmetoder som avhenger av hvilken type organisasjon du tilhører. Den ansvarlige for organisasjonen må migrere selskapets hovedkonto og bli administrator, mens de øvrige ansatte må knytte seg til organisasjonen ved hjelp av den oppgitte ID-en.",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "Den oppgitte ID-en samsvarer ikke med noe selskap. Kontroller og prøv igjen",
    "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "DU HAR FOR MANGE MENYER. VI KUNNE IKKE UTFØRE DEN AUTOMATISKE IMPORTEN. KONTOEN DIN VIL BLI AKTIVERT, MEN MENYENE MÅ MIGRERES MANUELT.",
    "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "FOR Å MIGRERE MENYENE DINE, ETTER AT DU HAR LOGGET INN, KLIKKER DU PÅ NAVNET DITT ØVERST TIL HØYRE, DERETTER PÅ REDIGER KONTO OG TIL SLUTT PÅ IMPORTER MENYER.",
    "register.Atenção:": "Merk:",
    "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "Kun én person i organisasjonen kan opprette kontoen og, etter at den er aktivert, invitere de øvrige brukerne i selskapet til å få tilgang.",
    "register.TOKEN DESENVOLVEDOR CANCELADO": "UTVIKLERTOKEN ANNULLERT",
    "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "Passordet må være mellom 8 og 20 tegn langt og inneholde én stor bokstav, én liten bokstav, ett tall og ett spesialtegn",
    
    //HOME
    "home.Menus disponíveis na plataforma": "Menyer tilgjengelige på plattformen",
    "home.Criados na plataforma": "Opprettet på plattformen",
    "home.Recebidos dos fornos": "Mottatt fra ovnene",
    "home.Equipamentos vinculados": "Tilknyttede enheter",
    "home.Total de receitas cadastradas": "Totalt antall registrerte oppskrifter",
    "home.Receitas": "Oppskrifter",
    "home.Receitas em menus": "Oppskrifter i menyer",
    "home.Em menus": "I menyer",
    "home.Receitas salvas no Cookbook": "Oppskrifter lagret i Cookbook",
    "home.No Cookbook": "I Cookbook",
    "home.Atualizações": "Oppdateringer",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "Installert versjon",
    "home.Versão disponível": "Tilgjengelig versjon",
    "home.Usuários cadastrados": "Registrerte brukere",
    "home.Aceitação pendente": "Venter på godkjenning",
    "home.Atualizado": "Oppdatert",
    "home.OLÁ": "HEI",
    "home.É muito bom ter você aqui!": "Så hyggelig å ha deg her!",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "Med IOK-plattformen kan du administrere ovnene dine uansett hvor du er, opprette og administrere oppskrifter og menyer, lage sikkerhetskopier, analysere data fra utstyret ditt og mye mer!",
    "home.Conheça a plataforma": "Bli kjent med plattformen",
    "home.Taxa de erro por modelo": "Feilrate per modell",
    "home.Erro": "Feil",
    "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "VI ØNSKER Å HØRE DIN MENING OM",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "Vi setter stor pris på ditt synspunkt, og derfor har vi laget denne tilfredshetsundersøkelsen om {model}-plattformen!",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "Vi setter stor pris på ditt synspunkt, og derfor har vi laget denne tilfredshetsundersøkelsen om {model}-serien!",
    "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Svarene dine vil hjelpe oss med å forbedre tjenestene våre, slik at vi kan fortsette å gi deg den best mulige opplevelsen.",
    "home.Reserve uns minutinhos de seu dia e participe!": "Sett av noen minutter av dagen din og delta!",
    "home.Responder a pesquisa": "Svar på undersøkelsen",
    "home.Modelos em evidência": "Fremhevede modeller",
    "home.Modelos": "Modeller",
    "home.Total de equipamentos vinculados": "Totalt antall tilknyttede enheter",
    "home.Total de equipamentos online": "Totalt antall enheter på nett",
    "home.Equipamentos online": "Enheter på nett",
    "home.Países com Prática": "Land med Prática",
    "home.Países": "Land",
    "home.Aguarde enquanto carregamos os dados": "Vennligst vent mens vi laster inn dataene",
    "home.Quase lá! Aguarde um pouco mais": "Nesten ferdig! Vent litt til",
    "home.Vendas por Equipamento": "Salg per enhet",
    "home.Total de equipamentos vendidos": "Totalt antall solgte enheter",
    "home.Equipamentos vendidos": "Solgte enheter",
    "home.Clique para atualizar o software": "Klikk for å oppdatere programvaren",
    "home.Aceitação de software pendente": "Venter på godkjenning av programvare",
    "home.Software atualizado": "Programvaren er oppdatert",
    "home.NENHUM EQUIPAMENTO VINCULADO": "INGEN TILKNYTTEDE ENHETER",
    "home.FORNOS LIGADOS": "OVNER I DRIFT",
    "home.Enviando dados": "Sender data",
    "home.Com conectividade IOK": "Med IOK-tilkobling",
    "home.Sem envio de dados": "Sender ikke data",
    "home.Sem conectividade IOK": "Uten IOK-tilkobling",
    "home.Criados na Plataforma": "Opprettet på plattformen",
    "home.Apenas no Cookbook": "Kun i Cookbook",
    "home.Usuários na companhia": "Brukere i selskapet",
    "home.Inativos": "Inaktive",
    "home.Online": "På nett",
    "home.Atualizações de equipamentos": "Enhetsoppdateringer",
    "home.Modelos de equipamentos": "Enhetsmodeller",
    "home.Atualizados": "Oppdatert",
    "home.Aguardando Aceite": "Venter på godkjenning",
    "home.Desatualizados": "Ikke oppdatert",
    
    //MAIN
    "main.HOME": "HJEM",
    "main.COOKBOOK": "COOKBOOK",
    "main.MEUS MENUS": "MINE MENYER",
    "main.EQUIPAMENTOS": "ENHETER",
    "main.USUÁRIOS": "BRUKERE",
    "main.ATENDIMENTOS": "SUPPORT",
    "main.Idioma": "Språk",
    "main.Editar conta": "Rediger konto",
    "main.Configurações": "Innstillinger",
    "main.Sair": "Logg ut",
    "main.Configurações salvas com sucesso!": "Innstillingene ble lagret!",
    "main.SALVAR": "LAGRE",
    "main.CONFIGURAÇÕES": "INNSTILLINGER",
    "main.Tema dark": "Mørkt tema",
    "main.Notificações": "Varsler",
    "main.Informações para as receitas": "Informasjon for oppskrifter",
    "main.Peso:": "Vekt:",
    "main.Gramas": "Gram",
    "main.Oz": "Oz",
    "main.Temperatura:": "Temperatur:",
    "main.Fahrenheit (°F)": "Fahrenheit (°F)",
    "main.Conta editada com sucesso!": "Kontoen ble oppdatert!",
    "main.EDITAR CONTA": "REDIGER KONTO",
    "main.Nome": "Navn",
    "main.Preencha com o seu nome": "Skriv inn navnet ditt",
    "main.Telefone": "Telefon",
    "main.Preencha com o seu telefone": "Skriv inn telefonnummeret ditt",
    "main.E-mail": "E-post",
    "main.Preencha com o seu e-mail": "Skriv inn e-postadressen din",
    "main.Alterar Senha": "Endre passord",
    "main.ALTERAR SENHA": "ENDRE PASSORD",
    "main.Senha atual": "Nåværende passord",
    "main.Nova senha": "Nytt passord",
    "main.Confirmar nova senha": "Bekreft nytt passord",
    "main.Informe sua senha atual": "Oppgi ditt nåværende passord",
    "main.O campo senha deve conter no mínimo 6 caracteres":
    "Passordfeltet må inneholde minst 6 tegn",
    "main.Informe sua nova senha": "Oppgi ditt nye passord",
    "main.Confirme sua nova senha": "Bekreft ditt nye passord",
    "main.Sua nova senha deve conter no mínimo 6 caracteres":
    "Det nye passordet må inneholde minst 6 tegn",
    "main.INFORME SUA SENHA": "OPPGI PASSORDET DITT",
    "main.Informe sua senha para realizar a alteração de e-mail da plataforma:":
    "Oppgi passordet ditt for å endre e-postadressen på plattformen:",
    "main.CONFIRMAR": "BEKREFT",
    "main.Existem campos que não foram preenchidos corretamente":
    "Noen felt er ikke fylt ut riktig",
    "main.Informe sua senha para prosseguir com a alteração de e-mail":
    "Oppgi passordet ditt for å fortsette med endringen av e-postadressen",
    "main.Senha alterada com sucesso": "Passordet ble endret",
    "main.Informe sua senha atual corretamente": "Oppgi ditt nåværende passord korrekt",
    "main.As senhas devem ser iguais": "Passordene må være identiske",
    "main.Nome do novo tipo de usuário": "Navn på den nye brukertypen",
    "main.Dê um nome para o novo tipo de usuário": "Gi den nye brukertypen et navn",
    "main.Token Desenvolvedor": "Utviklertoken",
    "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "Utviklertokenet er en unik og ikke-overførbar kode som gjør det mulig å utføre endringer på utviklingsnivå direkte i plattformens kode gjennom eksterne API-er. Dette gjør det mulig å tilpasse plattformen slik at den bedre dekker bedriftens behov.",
    "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "Det anbefales at disse endringene utføres av en teknologifaglig ekspert.",
    "main.Para acessar o token, informe sua senha": "Oppgi passordet ditt for å få tilgang til tokenet",
    "main.Copie e cole o token na autenticação de todas as requisições.": "Kopier og lim inn tokenet i autentiseringen av alle forespørsler.",
    "main.Seu Token": "Ditt token",
    "main.Token copiado com sucesso!": "Tokenet ble kopiert!",
    "main.Você deseja cancelar o preenchimento das informações?": "Vil du avbryte utfyllingen av informasjonen?",
    "main.Rever tutoriais": "Se veiledningene på nytt",
    "main.Tutoriais resetados com sucesso!": "Veiledningene ble tilbakestilt!",
    "main.review.tutorials": "Vil du se veiledningene for IOK-plattformen på nytt?",
    "main.Procurar": "Søk",
    "main.review.manual": "Du kan også lagre den på datamaskinen din.",
    "main.review.download": "Åpne håndboken",
    
    //MEUS MENUS
    "menus.Procurar menu": "Søk etter meny eller bruker",
    "menus.Procurar menu excluído": "Søk etter slettet meny",
    "menus.Menus": "Menyer",
    "menus.Lixeira": "Papirkurv",
    "menus.CRIAR MENU": "OPPRETT MENY",
    "menus.IMPORTAR MENU": "IMPORTER MENY",
    "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.":
    "Filene vil bli liggende i papirkurven i 30 dager fra slettedatoen. Etter denne perioden blir de slettet permanent.",
    "menus.VOLTAR": "tilbake",
    "menus.Compatível com: ": "Kompatibel med: ",
    "menus.Última atualização: ": "Siste oppdatering: ",
    "menus.EXPORTAR MENU": "EKSPORTER MENY",
    "menus.EDITAR MENU": "REDIGER MENY",
    "menus.Equipamentos associados": "Tilknyttede enheter",
    "menus.Grupos": "Grupper",
    "menus.Procurar grupo": "Søk etter gruppe",
    "menus.CRIAR GRUPO": "OPPRETT GRUPPE",
    "menus.receitas": "oppskrifter",
    "menus.Nenhum grupo cadastrado": "Ingen grupper registrert",
    "menus.Nenhum menu cadastrado": "Ingen menyer registrert",
    "menus.Nome": "Navn",
    "menus.Modelo": "Modell",
    "menus.Atividade": "Aktivitet",
    "menus.Associação": "Tilknytning",
    "menus.Exportar": "Eksporter",
    "menus.Editar": "Rediger",
    "menus.Excluir": "Slett",
    "menus.Equips": "Enheter",
    "menus.Receitas": "Oppskrifter",
    "menus.Compatibilidade": "Kompatibilitet",
    "menus.Última atualização": "Siste oppdatering",
    "menus.Versão": "Versjon",
    "menus.Origem": "Opprinnelse",
    "menus.Excluído por": "Slettet av",
    "menus.Data de exclusão": "Slettedato",
    "menus.Restaurar": "Gjenopprett",
    "menus.Existem campos que não foram preenchidos":
    "Det finnes felt som ikke er fylt ut",
    "menus.Menu criado com sucesso!": "Menyen ble opprettet!",
    "menus.Existem campos com informações inválidas":
    "Det finnes felt med ugyldig informasjon",
    "menus.SALVAR": "LAGRE",
    "menus.CANCELAR": "AVBRYT",
    "menus.Nome do menu": "Menynavn",
    "menus.Informe o nome do menu": "Oppgi menynavnet",
    "menus.Preencha o nome do menu sem caracteres especiais": "Skriv inn menynavnet uten spesialtegn",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Kun tegnene @#%&*-+()!\"<>:;\\/?. er tillatt",
    "menus.Selecionar": "Velg",
    "menus.Idioma": "Språk",
    "menus.Temperatura de pré-aquec 1": "Forvarmingstemperatur 1",
    "menus.Informe a temperatura de pré-aquec 1":
    "Oppgi forvarmingstemperatur 1",
    "menus.Temperatura de pré-aquec 2": "Forvarmingstemperatur 2",
    "menus.Informe a temperatura de pré-aquec 2":
    "Oppgi forvarmingstemperatur 2",
    "menus.Tempo para estabilização": "Tid for stabilisering",
    "menus.Informe o tempo para estabilização":
    "Oppgi stabiliseringstiden",
    "menus.Desativar pré-aquec 2": "Deaktiver forvarming 2",
    "menus.Configurações de data e hora": "Innstillinger for dato og klokkeslett",
    "menus.Data:": "Dato:",
    "menus.DD/MM/AAAA": "DD/MM/ÅÅÅÅ",
    "menus.Hora:": "Klokkeslett:",
    "menus.24h": "24 t",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: DD/MM/ÅÅÅÅ",
    "menus.USA: MM/DD/AAAA": "USA: MM/DD/ÅÅÅÅ",
    "menus.ISO: AAAA/MM/DD": "ISO: ÅÅÅÅ/MM/DD",
    "menus.Seleção de acessos para habilitar":
    "Velg tilganger som skal aktiveres",
    "menus.Modo manual": "Manuell modus",
    "menus.Habilitado": "Aktivert",
    "menus.Desabilitado": "Deaktivert",
    "menus.Favoritos": "Favoritter",
    "menus.Aquecer/Dourar": "Varme opp/Bryne",
    "menus.Repetir receita": "Gjenta oppskrift",
    "menus.Configurações gerais do menu": "Generelle menyinnstillinger",
    "menus.Temperatura:": "Temperatur:",
    "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
    "menus.Gramas": "Gram",
    "menus.Oz": "Oz",
    "menus.Tema:": "Tema:",
    "menus.Dark": "Mørkt",
    "menus.Light": "Lyst",
    "menus.Introdução:": "Introduksjon:",
    "menus.Ativada": "Aktivert",
    "menus.Desativada": "Deaktivert",
    "menus.Menu deletado com sucesso!": "Menyen ble slettet!",
    "menus.Não foi possivel deletar o menu": "Kunne ikke slette menyen",
    "menus.Sim": "Ja",
    "menus.Não": "Nei",
    "menus.Excluir definitivamente": "Slett permanent",
    "menus.SALVAR NO DISPOSITIVO": "LAGRE PÅ ENHETEN",
    "menus.EXPORTAR": "EKSPORTER",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.":
    "Velg modellene og versjonene av enhetene som skal motta menyen.",
    "menus.Forno": "Ovn",
    "menus.Fundo verde": "Grønn bakgrunn",
    "menus.Fundo preto": "Svart bakgrunn",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.":
    "Merk: Før du overfører menyen fra USB-minnet til enheten, må filen pakkes ut, unntatt for menyer til Linux-enheter.",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.":
    "Velg enhetene du vil eksportere menyen til.",
    "menus.Nome do equipamento": "Enhetsnavn",
    "menus.Selecionar todos": "Velg alle",
    "menus.Selecionar todas": "Velg alle",
    "menus.Categoria: ": "Kategori: ",
    "menus.Você deseja excluir o menu?": "Vil du slette menyen?",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.":
    "Menyen blir slettet fra plattformen, men blir værende på enheten. En sikkerhetskopi opprettes automatisk og vil være tilgjengelig i 30 dager under Mine menyer – Papirkurv.",
    "menus.Você deseja excluir o arquivo definitivamente?":
    "Vil du slette filen permanent?",
    "menus.Esta ação não poderá ser desfeita.":
    "Denne handlingen kan ikke angres.",
    "menus.Menu editado com sucesso!": "Menyen ble oppdatert!",
    "menus.IMPORTAR": "IMPORTER",
    "menus.VERIFICAÇÃO DE VERSÃO": "VERSJONSKONTROLL",
    "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:":
    "Følg disse trinnene for å kontrollere kortversjonen på enheten din:",
    "menus.No forno, acesse Configurações;": "Gå til Innstillinger på ovnen;",
    "menus.Insira a senha 456789;": "Skriv inn passordet 456789;",
    "menus.Selecione a opção Sistema;": "Velg alternativet System;",
    "menus.Selecione Informações do Fabricante;":
    "Velg Produsentinformasjon;",
    "menus.O modelo de sua placa estará na linha Firmware IHM;":
    "Kortmodellen vises på linjen Firmware IHM;",
    "menus.1ª geração A": "1. generasjon A",
    "menus.Firmware IHM: 12.3.4": "Firmware IHM: 12.3.4",
    "menus.1ª geração B": "1. generasjon B",
    "menus.2ª geração/Linux:": "2. generasjon/Linux:",
    "menus.Firmware IHM: L1.2.3": "Firmware IHM: L1.2.3",
    "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento":
    "Velg modell/versjon av enheten du vil importere menyen fra. Lær hvordan du kontrollerer versjonen på enheten din ",
    "menus.Como verificar a versão da placa":
    "Slik kontrollerer du kortversjonen",
    "menus.1° Geração": "1. generasjon",
    "menus.Menu restaurado com sucesso!": "Menyen ble gjenopprettet!",
    "menus.Não foi possivel restaurar o menu":
    "Kunne ikke gjenopprette menyen",
    "menus.RESTAURAR ARQUIVO": "GJENOPPRETT FIL",
    "menus.Você deseja restaurar o arquivo?":
    "Vil du gjenopprette filen?",
    "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.":
    "Filen blir gjenopprettet som en ny versjon på plattformen under fanen Alle. For å lagre den på enheten må du eksportere den.",
    "menus.EXCLUIR MENU": "SLETT MENY",
    "menus.Nenhum equipamento associado": "Ingen tilknyttede enheter",
    "menus.Nomeie o novo menu": "Gi den nye menyen et navn",
    "menus.Nomeie o novo grupo": "Gi den nye gruppen et navn",
    "menus.Nome do grupo": "Gruppenavn",
    "menus.Preencha o nome do grupo sem caracteres especiais": "Skriv inn gruppenavnet uten spesialtegn",
    "menus.Pré-aquecimento:": "Forvarming:",
    "menus.Grupo criado com sucesso!": "Gruppen ble opprettet!",
    "menus.SELECIONE UMA IMAGEM": "VELG ET BILDE",
    "menus.SELECIONAR": "VELG",
    "menus.Selecionar do dispositivo": "Velg fra enheten",
    "menus.Selecionar do banco de imagens": "Velg fra bildebiblioteket",
    "menus.Formato .JPG ou .PNG": "Format .JPG eller .PNG",
    "menus.Procurar imagem": "Søk etter bilde",
    "menus.Pertence ao menu": "Tilhører menyen",
    "menus.Alterar imagem": "Endre bilde",
    "menus.Remover imagem": "Fjern bilde",
    "menus.EDITAR GRUPO": "REDIGER GRUPPE",
    "menus.Nome:": "Navn:",
    "menus.CRIAR RECEITA": "OPPRETT OPPSKRIFT",
    "menus.SALVAR DO COOKBOOK": "LAGRE FRA COOKBOOK",
    "menus.Procurar receita do grupo": "Søk etter gruppeoppskrift",
    "menus.Ingrediente principal": "Hovedingrediens",
    "menus.Limpar filtros": "Fjern filtre",
    "menus.Filtrar": "Filtrer",
    "menus.Mover receitas": "Flytt oppskrifter",
    "menus.Excluir receitas": "Slett oppskrifter",
    "menus.Editar grupo": "Rediger gruppe",
    "menus.Excluir grupo": "Slett gruppe",
    "menus.aqui": "her",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.":
    "Hvis koden kun består av tall og skjermbakgrunnen er grønn, tilhører den 1. A. Hvis den kun består av tall og skjermbakgrunnen er svart, tilhører den 1. B. Hvis den begynner med bokstavene L, F eller S, tilhører kortet ditt 2. generasjon/Linux.",
    "menus.1ª A - Fundo verde": "1. A - Grønn bakgrunn",
    "menus.1ª B - Fundo preto": "1. B - Svart bakgrunn",
    "menus.2ª - Linux": "2. - Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.":
    "Det oppstod et problem. Prøv igjen senere.",
    "menus.Grupo editado com sucesso!": "Gruppen ble oppdatert!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "DET FINNES ENNÅ INGEN GRUPPER HER :(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Klikk på knappen øverst til høyre og legg til grupper.",
    "menus.NENHUM MENU NA LIXEIRA": "INGEN MENYER I PAPIRKURVEN",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "DET FINNES ENNÅ INGEN MENYER HER :(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Klikk på en av knappene øverst til høyre og legg til menyer.",
    "menus.Adicionar imagem": "Legg til bilde",
    "menus.Nome da receita": "Oppskriftsnavn",
    "menus.Detalhes da receita": "Oppskriftsdetaljer",
    "menus.Programação da receita": "Oppskriftsprogrammering",
    "menus.Nomeie sua receita": "Gi oppskriften et navn",
    "menus.Preencha o nome da receita sem caracteres especiais": "Skriv inn oppskriftsnavnet uten spesialtegn",
    "menus.Tipo de prato": "Type rett",
    "menus.SALVAR RECEITAS DO COOKBOOK": "LAGRE OPPSKRIFTER FRA COOKBOOK",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:":
    "Velg oppskriftene du vil lagre i menygruppen:",
    "menus.Procurar receita": "Søk etter oppskrift",
    "menus.deleteGroupSuccess":
    "{count, plural, one {Gruppen ble slettet!} other {Gruppene ble slettet!}}",
    "menus.deleteGroupError":
    "{count, plural, one {Kunne ikke slette gruppen.} other {Kunne ikke slette gruppene.}}",
    "menus.EXCLUIR GRUPO": "SLETT GRUPPE",
    "menus.confirmDeleteGroupMessage":
    "{count, plural, one {Vil du slette gruppen permanent?} other {Vil du slette gruppene permanent?}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "DET FINNES ENNÅ INGEN OPPSKRIFTER HER :(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Klikk på en av knappene øverst til høyre og legg til oppskrifter.",
    "menus.Temp. de entrada": "Inngangstemp.",
    "menus.Temp. de pré-aquec": "Forvarmingstemp.",
    "menus.Ingredientes para montagem": "Ingredienser til montering",
    "menus.Instruções operacionais": "Bruksanvisning",
    "menus.Passo": "Trinn",
    "menus.Temp": "Temp ",
    "menus.Temp.": "Temp. ",
    "menus.Tempo": "Tid",
    "menus.Velocidade do ar": "Lufthastighet",
    "menus.Micro-ondas": "Mikrobølger",
    "menus.Resistência inferior": "Nedre varmeelement",
    "menus.Informações": "Informasjon",
    "menus.Digite as informações do passo": "Skriv inn informasjonen for trinnet",
    "menus.desativar": "deaktiver",
    "menus.Ingredientes": "Ingredienser",
    "menus.Temperatura de entrada": "Inngangstemperatur",
    "menus.Equipamentos compatíveis": "Kompatible enheter",
    "menus.Tempo total": "Total tid",
    "menus.SALVAR NO COOKBOOK": "LAGRE I COOKBOOK",
    "menus.ver localização": "vis plassering",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "VELG OPPSKRIFTER SOM SKAL SLETTES",
    "menus.Você deseja excluir as receitas selecionadas definitivamente?":
    "Vil du slette de valgte oppskriftene permanent?",
    "menus.Receitas deletadas com sucesso!": "Oppskriftene ble slettet!",
    "menus.Informe aqui os ingredientes para montagem":
    "Skriv inn ingrediensene til montering her",
    "menus.Informe aqui as instruções operacionais":
    "Skriv inn bruksanvisningen her",
    "menus.Adicionar passo": "Legg til trinn",
    "menus.Receita criada com sucesso!": "Oppskriften ble opprettet!",
    "menus.Ideal para:": "Ideell for: ",
    "menus.editar detalhes": "rediger detaljer",
    "menus.excluir": "slett",
    "menus.editar": "rediger",
    "menus.Receita editada com sucesso!": "Oppskriften ble oppdatert!",
    "menus.Passo deletado com sucesso!": "Trinnet ble slettet!",
    "menus.Não foi possivel deletar o passo":
    "Kunne ikke slette trinnet",
    "menus.EXCLUIR PASSO": "SLETT TRINN",
    "menus.Você deseja excluir este passo?": "Vil du slette dette trinnet?",
    "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.":
    "Denne handlingen kan ikke angres. Hvis du foretrekker det, kan du i stedet deaktivere trinnet og beholde innstillingene.",
    "menus.Peso": "Vekt",
    "menus.Origem da receita": "Oppskriftens opprinnelse",
    "menus.Pré-aquecimento": "Forvarming",
    "menus.Plataforma": "Plattform",
    "menus.Receita salva com sucesso!": "Oppskriften ble lagret!",
    "menus.Exportar receitas": "Eksporter oppskrifter",
    "menus.expandir": "utvid",
    "menus.Temperatura": "Temperatur",
    "menus.Vapor combinado": "Kombidamp",
    "menus.Ar quente": "Varmluft",
    "menus.Sonda": "Temperaturføler",
    "menus.Tempo (min)": "Tid (min)",
    "menus.Umidade (%)": "Fuktighet (%)",
    "menus.Injeção de vapor": "Dampinjeksjon",
    "menus.Dumper aberto": "Åpen spjeldventil",
    "menus.Informe o peso": "Oppgi vekten",
    "menus.Informe a temperatura de entrada":
    "Oppgi inngangstemperaturen",
    "menus.Informe os ingredientes para montagem":
    "Oppgi ingrediensene til montering",
    "menus.Informe as instruções operacionais":
    "Oppgi bruksanvisningen",
    "menus.Injeção de vapor (seg)": "Dampinjeksjon (sek)",
    "menus.Aquecer mais": "Varm opp mer",
    "menus.Dourar mais": "Brun mer",
    "menus.Aquecer e dourar mais": "Varm opp og brun mer",
    "menus.Favoritar receita": "Legg til oppskrift som favoritt",
    "menus.Informe o tempo para aquecer mais":
    "Oppgi tiden for å varme opp mer",
    "menus.Informe o tempo para dourar mais":
    "Oppgi tiden for å brune mer",
    "menus.Informe o tempo para aquecer e dourar mais":
    "Oppgi tiden for å varme opp og brune mer",
    "menus.Apenas favoritos": "Kun favoritter",
    "menus.Forno combinado": "Kombiovn",
    "menus.Cocção múltipla": "Flertrinnssteking",
    "menus.Receitas Technicook": "Technicook-oppskrifter",
    "menus.Editar grupos": "Rediger grupper",
    "menus.Informe a data": "Oppgi datoen",
    "menus.Informe a hora": "Oppgi klokkeslettet",
    "menus.até 300": "opptil 300",
    "menus.Vapor": "Damp",
    "menus.Turbina": "Vifte",
    "menus.Criar grupo": "Opprett gruppe",
    "menus.MOVER": "FLYTT",
    "menus.Configurações de data e hora:": "Innstillinger for dato og klokkeslett:",
    "menus.Configurações de acessos:": "Tilgangsinnstillinger:",
    "menus.Modo manual:": "Manuell modus:",
    "menus.Favoritos:": "Favoritter:",
    "menus.Aquecer/dourar:": "Varm opp/brun:",
    "menus.Repetir receita:": "Gjenta oppskrift:",
    "menus.Configurações gerais do menu:": "Generelle menyinnstillinger:",
    "menus.SELECIONE RECEITAS PARA MOVER": "VELG OPPSKRIFTER SOM SKAL FLYTTES",
    "menus.AVANÇAR": "NESTE",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "Velg eller opprett en gruppe i samme meny for å flytte de valgte oppskriftene, eller flytt dem til en annen meny. Merk at bare menyer/grupper som er kompatible med oppskriftenes forhåndsinnstillinger vil bli vist.",
    "menus.Mover receitas para o mesmo menu": "Flytt oppskrifter til samme meny",
    "menus.Mover receitas para outro menu": "Flytt oppskrifter til en annen meny",
    "menus.Selecionar grupo": "Velg gruppe",
    "menus.Nenhuma receita foi selecionada": "Ingen oppskrift er valgt",
    "menus.Passo editado com sucesso!": "Trinnet ble oppdatert!",
    "menus.Menu atualizado": "Meny oppdatert",
    "menus.até 260": "opptil 260",
    "menus.Umidade na câmara": "Fuktighet i kammeret",
    "menus.Passos": "Trinn",
    "menus.ativar": "aktiver",
    "menus.Informe a temperatura de pré-aquec": "Oppgi forvarmingstemperaturen",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.":
    "Flytt de valgte oppskriftene til en annen meny. Merk at bare menyer som er kompatible med oppskriftenes forhåndsinnstillinger vil bli vist.",
    "menus.Sonda (°C)": "Temperaturføler (°C)",
    "menus.Turbo Grill": "Turbo Grill",
    "menus.Pré-aquecimento padrão, conforme passo 1": "Standard forvarming, i henhold til trinn 1",
    "menus.salvar": "lagre",
    "menus.até": "opptil",
    "menus.Verificação de receita": "Oppskriftskontroll",
    "menus.Auto import": "Automatisk import",
    "menus.Atualização forçada": "Tvungen oppdatering",
    "menus.Lista de receitas exportada com sucesso!": "Oppskriftslisten ble eksportert!",
    "menus.Receita movida com sucesso!": "Oppskriften ble flyttet!",
    "menus.Receitas movidas com sucesso!": "Oppskriftene ble flyttet!",
    "menus.+ Menu": "+ Meny",
    "menus.+ Receita": "+ Oppskrift",
    "menus.Selecione o modelo/versão do equipamento": "Velg modell/versjon av enheten",
    "menus.Escolha um idioma compatível com o equipamento": "Velg et språk som er kompatibelt med enheten",
    "menus.MENU IMPORTADO COM SUCESSO!": "MENYEN BLE IMPORTERT!",
    "menus.Dourar": "Brun",
    "menus.Não atribuir a menu": "Ikke tilordne til meny",
    "menus.Todos": "Alle",
    "menus.Meus menus": "Mine menyer",
    "menus.Para salvar uma receita, preencha todos os campos": "For å lagre en oppskrift må du fylle ut alle feltene",
    "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Velg enhetsgruppene du vil eksportere menyen til.",
    "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Ugyldig format. Kun .jpeg- og .png-formatene er tillatt",
    "menus.Reordenar grupos": "Endre rekkefølge på grupper",
    "menus.O que deseja fazer?": "Hva ønsker du å gjøre?",
    "menus.Reordenar receitas": "Endre rekkefølge på oppskrifter",
    "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "ELEMENTENE BLE OMRANGERT! FOR Å BRUKE ENDRINGENE PÅ OVNEN MÅ DU EKSPORTERE MENYEN.",
    "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "DRA ELEMENTENE TIL ØNSKET PLASSERING",
    "menus.Dumper": "Spjeld",
    "menus.Aberto": "Åpen",
    "menus.Fechado": "Lukket",
    "menus.Intermitente": "Periodisk",
    "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "Hvis menyen din inneholder produkter som er følsomme for jevn steking, anbefaler vi å sette stabiliseringstiden til mellom 3:00 og 5:00 minutter. Ellers kan du la den stå på 5 sekunder.",
    "menus.Selecione o menu que deseja exportar:": "Velg menyen du vil eksportere:",
    "menus.Temperatura de pré-aquecimento": "Forvarmingstemperatur",
    "menus.Temperatura de lastro": "Stekeplatetemperatur",
    "menus.Temperatura de teto": "Overvarmetemperatur",
    "menus.Volume de injeção de vapor (ml)": "Volum for dampinjeksjon (ml)",
    "menus.Parada de turbina": "Viftestopp",
    "menus.Alta": "Høy",
    "menus.Média": "Middels",
    "menus.Baixa": "Lav",
    "menus.a": "til",
    "menus.Valor da injeção": "Injeksjonsverdi",
    "menus.Volume: até 999ml": "Volum: opptil 999 ml",
    "menus.Tempo: até 15 segundos": "Tid: opptil 15 sekunder",
    "menus.Tempo de injeção de vapor (seg)": "Tid for dampinjeksjon (sek)",
    "menus.Atenção!": "Merk!",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Kontroller oppskriftene i menyen og juster verdiene for dampinjeksjon etter at du har endret måleenheten.",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Kontroller at temperaturenheten (°C eller °F) som er angitt på enheten, er den samme som ble valgt da menyen ble opprettet:",
    "menus.Injeção desativada": "Dampinjeksjon deaktivert",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Velg temperaturenheten som er angitt på enheten:",
    "menus.Clique para atualizar": "Klikk for å oppdatere",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "Funksjonen Tvungen oppdatering sender automatisk menyen til de valgte enhetene som har en versjon kompatibel med denne typen oppdatering, neste gang de slås på. Ovner som ennå ikke er oppdatert, må fortsatt godkjenne oppdateringen manuelt.",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "De valgte alternativene vil være tilgjengelige på enhetene som mottar denne menyen, og kan brukes av operatøren. Disse innstillingene kan senere endres direkte på ovnen eller via plattformen.",
    "menus.Não foi possivel deletar as receitas": "Kunne ikke slette oppskriftene",
    "menus.PRÉ": "FORVARMING",
    "menus.Speed Ovens": "Speed Ovens",
    "menus.Fornos Combinados": "Kombiovner",
    "menus.Fornos de Panificação": "Bakeovner",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "Etter at menyen er opprettet, kan menytypen ikke endres. Den kan bare angis ved opprettelsen.",
    "menus.Pré-aquecimento do grupo": "Gruppeforvarming",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Merk: Før du overfører menyen fra USB-minnet til enheten, må filen pakkes ut, og mappen PRATICA må overføres til enheten.",
    "menus.Tamanho máximo": "Maksimal størrelse",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Gjør det mulig for ovnsoperatøren å opprette parametere og deretter bruke dem.",
    "menus.Acesso também à execução das receitas favoritas.": "Gir også tilgang til tilberedning av favorittoppskrifter.",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Gjør det mulig for operatøren å legge til mer tid for oppvarming/bruning av maten etter at tilberedningen er fullført.",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Gjør det mulig å gjenta oppskriften så snart tilberedningen er fullført.",
    "menus.Acesso exclusivo às receitas favoritas.": "Gir eksklusiv tilgang til favorittoppskrifter.",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Aktiverer en påminnelse slik at operatøren kan kontrollere at maten er satt inn i ovnen.",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "Ovnen importerer automatisk en meny som er lagret på en tilkoblet USB-minnepinne når den slås på.",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Gjør det mulig å tilberede flere matvarer samtidig, én i hver GN-beholder.",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Gir tilgang til fabrikkforhåndsprogrammerte oppskrifter.",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Gir tilgang til Turbo Grill-funksjonen, som når opptil 300 °C.",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Gjør det mulig for operatøren å legge til mer tid for bruning av maten etter at tilberedningen er fullført.",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Lar operatøren redigere oppskriftsgrupper direkte fra startskjermen.",
    "menus.Copiar grupos": "Kopier grupper",
    "menus.Excluir grupos": "Slett grupper",
    "menus.Copiar": "Kopier",
    "menus.Selecione grupos para copiar": "Velg grupper som skal kopieres",
    "menus.Selecione o destino dos grupos": "Velg mål for gruppene",
    "menus.Colar": "Lim inn",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "Vil du avbryte kopieringen og sendingen av grupper til menyene?",
    "menus.Grupos colados com sucesso": "{count, plural, one {Gruppen ble limt inn!} other {Gruppene ble limt inn!}}",
    "menus.Copiar receitas": "Kopier oppskrifter",
    "menus.Selecione receitas para copiar": "Velg oppskrifter som skal kopieres",
    "menus.Selecione o destino das receitas": "Velg mål for oppskriftene",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "Vil du avbryte kopieringen og sendingen av oppskrifter til gruppene?",
    "menus.Receitas coladas com sucesso": "{count, plural, one {Oppskriften ble limt inn!} other {Oppskriftene ble limt inn!}}",
    "menus.Converter para C-MAX EVO": "Konverter til C-MAX EVO",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "En kopi av denne menyen, tilpasset C-MAX EVO, vil bli opprettet. Vi anbefaler at du nøye gjennomgår alle trinnparametrene og oppdaterer oppskriftene med nye bilder dersom du mener det er nødvendig.",
    "menus.Menu convertido com sucesso!": "Menyen ble konvertert!",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "Kunne ikke konvertere menyen. Prøv igjen senere",
    "menus.O menu está sendo convertido... Aguarde!": "Menyen konverteres... Vennligst vent!",
    "menus.Menu incompatível com": "Menyen er ikke kompatibel med",
    "menus.Selecione pelo menos um grupo": "Velg minst én gruppe",
    "menus.Selecione pelo menos um menu": "Velg minst én meny",
    "menus.Menu atual": "Gjeldende meny",
    "menus.Copiando grupos": "{count, plural, one {Gruppen kopieres... Vennligst vent!} other {Gruppene kopieres... Vennligst vent!}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {Kunne ikke kopiere gruppen. Prøv igjen senere!} other {Kunne ikke kopiere gruppene. Prøv igjen senere!}}",
    "menus.Procurar pelo nome do menu": "Søk etter menynavn",
    "menus.Escolha um grupo de destino para cada menu selecionado": "Velg en målgruppe for hver valgt meny!",
    "menus.Copiando receitas": "{count, plural, one {Oppskriften kopieres... Vennligst vent!} other {Oppskriftene kopieres... Vennligst vent!}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {Kunne ikke kopiere oppskriften. Prøv igjen senere!} other {Kunne ikke kopiere oppskriftene. Prøv igjen senere!}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "VELG GRUPPER SOM SKAL SLETTES",
    "menus.Padeiro noturno": "Nattbaker",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Gjør det mulig å programmere starten (forvarmingen) av en bestemt oppskrift eller en oppskrift angitt manuelt (Manuell modus), uten at en operatør trenger å være til stede.",
    "menus.Vaporizador": "Dampgenerator",
    "menus.Editar receitas": "Rediger oppskrifter",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Lar operatøren redigere oppskrifter direkte fra startskjermen.",
    "menus.Preencha o nome da receita": "Skriv inn oppskriftsnavnet",
    "menus.Tempo nível": "Nivåtid",
    "menus.Fermentadora": "Heveskap",
    "menus.0 ou 5 a 59s": "0 eller 5 til 59 s",
    "menus.Selecione uma imagem" : "Velg et bilde",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*For å opprette oppskrifter for ovner uten tilkobling må du først opprette en meny og deretter oppskriftene.",
    "menus.CONVERTER": "KONVERTER",
    "menus.Converter para FIT": "Konverter til FIT",
    "menus.Converter para outro FIT": "Konverter til en annen FIT",
    "menus.Selecione pelo menos um modelo FIT": "Velg minst én FIT-modell",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "Menyen konverteres til FIT... Vennligst vent!",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} meny(er) ble konvertert til FIT!",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Noen menyer ble konvertert, men konverteringen mislyktes for: {models}",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "En kopi av denne menyen vil bli opprettet for hver valgt FIT-modell, med innstillinger, grupper, oppskrifter og trinn beholdt.",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu." : "En kopi av denne menyen vil bli opprettet for hver valgt FIT-modell, med innstillinger, grupper, oppskrifter og trinn beholdt. Siden hver ovn har spesifikke dimensjoner og egenskaper, anbefaler vi imidlertid at du gjennomgår og justerer parameterne for å sikre best mulig ytelse og resultat på hver enhet. Velg FIT-modellen du ønsker å konvertere menyen til.",
    
    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "TILGJENGELIGE OPPSKRIFTER",
    "cookbook.RECEITAS SALVAS": "LAGREDE OPPSKRIFTER",
    "cookbook.ENVIAR PARA MENU": "SEND TIL MENY",
    "cookbook.SALVAR": "LAGRE",
    "cookbook.salvar": "lagre",
    "cookbook.Filtrar por": "Filtrer etter",
    "cookbook.Procurar receita do cookbook": "Søk etter oppskrift i Cookbook",
    "cookbook.Equipamento": "Enhet",
    "cookbook.Ingrediente principal": "Hovedingrediens",
    "cookbook.Tipo de prato": "Type rett",
    "cookbook.Região": "Region",
    "cookbook.Pré-aquecimento": "Forvarming",
    "cookbook.Procurar receita": "Søk etter oppskrift",
    "cookbook.Menu": "Meny",
    "cookbook.ENVIAR": "SEND",
    "cookbook.Procurar nome do menu": "Søk etter menynavn",
    "cookbook.Escolha um grupo deste menu": "Velg en gruppe fra denne menyen",
    "cookbook.Selecionar grupo": "Velg gruppe",
    "cookbook.Tivemos um problema. Tente novamente mais tarde":
    "Det oppstod et problem. Prøv igjen senere",
    "cookbook.Receita adicionada com sucesso!": "Oppskriften ble lagt til!",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde":
    "Kunne ikke legge til oppskriften. Prøv igjen senere",
    "cookbook.Selecione um menu e um grupo para enviar esta receita":
    "Velg en meny og en gruppe for å sende denne oppskriften",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados":
    "Oppskriften ble ikke lagt til menyen fordi det ikke finnes noen opprettede grupper",
    "cookbook.Selecione o modelo do equipamento primeiro": "Velg enhetsmodell først",
    "cookbook.Grupo": "Gruppe",
    "cookbook.Não foi possível salvar os passos da receita": "Kunne ikke lagre oppskriftstrinnene",
    "cookbook.Bovina": "Storfekjøtt",
    "cookbook.Frango": "Kylling",
    "cookbook.Ovos": "Egg",
    "cookbook.Pães": "Brød",
    "cookbook.Peixes": "Fisk",
    "cookbook.Queijo": "Ost",
    "cookbook.Suína": "Svinekjøtt",
    "cookbook.Vegetais": "Grønnsaker",
    "cookbook.Outros": "Andre",
    "cookbook.Entradas/aperitivos": "Forretter/snacks",
    "cookbook.Principais": "Hovedretter",
    "cookbook.Snacks": "Snacks",
    "cookbook.Pizzas": "Pizza",
    "cookbook.Massas": "Pasta",
    "cookbook.Acompanhamentos": "Tilbehør",
    "cookbook.Sobremesas": "Desserter",
    "cookbook.Manhã": "Morgen",
    "cookbook.Padaria": "Bakeri",
    "cookbook.Todos": "Alle",
    "cookbook.Não atribuir origem": "Ikke angi opprinnelse",
    "cookbook.Brasil": "Brasil",
    "cookbook.Alemanha": "Tyskland",
    "cookbook.França": "Frankrike",
    "cookbook.Rússia": "Russland",
    "cookbook.China": "Kina",
    "cookbook.Japão": "Japan",
    "cookbook.Itália": "Italia",
    "cookbook.Egito": "Egypt",
    "cookbook.Grécia": "Hellas",
    "cookbook.Argentina": "Argentina",
    "cookbook.África": "Afrika",
    "cookbook.Estados Unidos": "USA",
    "cookbook.Coreia": "Korea",
    "cookbook.Turquia": "Tyrkia",
    "cookbook.Ideal para": "Ideell for",
    "cookbook.Polônia": "Polen",
    "cookbook.Sanduíches": "Smørbrød",
    "cookbook.Nova Receita": "Ny oppskrift",
    
    //EQUIPAMENTOS
    "equipment.equipamentos": "enheter",
    "equipment.procurar equipamento": "Søk etter enhet eller bruker",
    "equipment.adicionar equipamento": "legg til enhet",
    "equipment.atualizar equipamento": "oppdater enhet",
    "equipment.+ equipamentos": "+ enheter",
    "equipment.buscar equipamento": "Søk etter enhet",
    "equipment.Desvincular": "Fjern tilknytning",
    "equipment.Editar": "Rediger",
    "equipment.sem conteúdo": "DET FINNES ENNÅ INGEN ENHETER HER :(",
    "equipment.description.sem conteúdo": "Klikk på knappen Legg til enhet øverst til høyre for å koble til ovnene dine.",
    "equipment.editar equipamento": "rediger enhet",
    "equipment.equipamento editado com sucesso!": "Enheten ble oppdatert!",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "Kunne ikke oppdatere enheten. Prøv igjen senere",
    "equipment.Menu exportado com sucesso!": "Menyen ble eksportert!",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "Kunne ikke eksportere menyen. Prøv igjen senere",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "Velg minst én enhet for å sende menyen",
    "equipment.Informações do menu": "Menyinformasjon",
    "equipment.Procurar receita ou grupo": "Søk etter oppskrift eller gruppe",
    "equipment.Grupo": "Gruppe",
    "equipment.Grupos de equipamentos": "Utstyrsgrupper",
    "equipment.Receita": "Oppskrift",
    "equipment.Quantidade": "Antall",
    "equipment.Receitas mais preparadas no equipamento durante o período": "Oppskrifter som ble tilberedt oftest på enheten i perioden",
    "equipment.Informações de limpeza": "Rengjøringsinformasjon",
    "equipment.Data da limpeza": "Rengjøringsdato",
    "equipment.Hora da limpeza": "Rengjøringstid",
    "equipment.nome": "Navn",
    "equipment.modelo": "Modell",
    "equipment.categoria": "Kategori",
    "equipment.loja": "Butikk",
    "desvincular equipamento": "Fjern tilknytning til enhet",
    "equipment.unlink.paragrafo 1":
    "Vil du fjerne enhetens tilknytning til IOK-plattformen?",
    "equipment.unlink.paragrafo 2":
    "Hvis du gjør dette, vil du ikke lenger kunne administrere innstillinger og menyer via plattformen, med mindre du kobler enheten til på nytt ved å følge tilkoblingsinstruksjonene.",
    "equipamento desvinculado com sucesso!":
    "Enhetens tilknytning ble fjernet!",
    "equipment.ocorreu um erro. Tente novamente mais tarde": "Det oppstod en feil. Prøv igjen senere",
    "equipment.sim": "Ja",
    "equipment.não": "Nei",
    "equipment.Encerrar acesso remoto": "Avslutt ekstern tilgang",
    "equipment.Horas sem limpeza": "Timer uten rengjøring",
    "equipment.Histórico de eventos": "Hendelseshistorikk",
    "equipment.Histórico de eventos do forno": "Hendelseshistorikk for ovn",
    "equipment.Histórico de eventos da fermentadora": "Hendelseshistorikk for heveskap",
    "equipment.Receitas executadas": "Tilberedte oppskrifter",
    "equipment.Hoje": "I dag",
    "equipment.Tempo de porta aberta": "Tid med åpen dør",
    "equipment.Tempo médio aproximado": "Omtrentlig gjennomsnittstid",
    "equipment.Filtrar eventos": "Filtrer hendelser",
    "equipment.Evento": "Hendelse",
    "equipment.Data": "Dato",
    "equipment.ERRO SENSOR RI": "Feil på nedre varmeelementsensor",
    "equipment.ERRO COM INV. DE FREQ.": "Feil på frekvensomformer",
    "equipment.ERRO MAGNETRON": "Magnetronfeil",
    "equipment.ERRO SENSOR CAMARA": "Feil på kammersensor",
    "equipment.ERRO CAN": "CAN-feil",
    "equipment.Erro INVERSOR DE FREQUENCIA": "Feil på frekvensomformer",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Feil i enhetsmodell",
    "equipment.ERRO PAINEL": "Panelfeil",
    "equipment.ERRO INV.FREQ.STATUS": "Statusfeil på frekvensomformer",
    "equipment.ERRO SENSOR BOARD": "Feil på kortsensor",
    "equipment.ERRO ENERGY": "Strømfeil",
    "equipment.ERRO I2C": "I2C-feil",
    "equipment.EQUIPAMENTO LIGADO": "Enheten er slått på",
    "equipment.EQUIPAMENTO DESLIGADO": "Enheten er slått av",
    "equipment.Plataforma": "Plattform",
    "equipment.Forno": "Ovn",
    "equipment.Origem": "Opprinnelse",
    "equipment.Locais": "Steder",
    "equipment.não foi possível carregar as entidades": "Kunne ikke laste inn enhetene",
    "equipment.conceder acesso remoto a": "Gi ekstern tilgang til",
    "equipment.atualizar software": "oppdater programvare",
    "equipment.suporte": "støtte",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "Enhetsnavn",
    "equipment.vinculado à loja": "Knyttet til butikk",
    "equipment.cadastrar loja": "Registrer butikk",
    "equipment.informe o PIN do forno": "Oppgi ovnens PIN",
    "equipment.preencha o PIN do forno": "Fyll inn ovnens PIN",
    "equipment.adicione um nome para facilitar seu reconhecimento":
    "Legg til et navn for enklere gjenkjenning",
    "equipment.preencha o nome do equipamento":
    "Fyll inn enhetsnavnet",
    "equipment.selecionar": "Velg",
    "equipment.nome fantasia": "Butikknavn",
    "equipment.informe o nome fantasia": "Oppgi butikknavnet",
    "equipment.preencha o nome fantasia": "Fyll inn butikknavnet",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
    "equipment.preencha o CNPJ": "Fyll inn CNPJ",
    "equipment.CEP": "Postnummer",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "Fyll inn postnummer",
    "equipment.cidade": "By",
    "equipment.informe a cidade": "Oppgi byen",
    "equipment.preencha a cidade": "Fyll inn byen",
    "equipment.UF": "Delstat",
    "equipment.bairro": "Bydel",
    "equipment.informe o bairro": "Oppgi bydelen",
    "equipment.endereço": "Adresse",
    "equipment.informe o seu endereço": "Oppgi adressen din",
    "equipment.preencha o seu endereço": "Fyll inn adressen din",
    "equipment.Nº": "Nr.",
    "equipment.equipamento cadastrado com sucesso!":
    "Enheten ble registrert!",
    "equipment.ocorreu um erro": "Det oppstod en feil",
    "equipment.preencha o modelo": "Fyll inn modellen",
    "equipment.selecione uma categoria": "Velg en kategori",
    "equipment.selecione uma loja": "Velg en butikk",
    "equipment.preencha o bairro": "Fyll inn bydelen",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde":
    "Kunne ikke registrere enheten. Prøv igjen senere",
    "equipment.loja cadastrada com sucesso": "Butikken ble registrert!",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde":
    "Kunne ikke registrere butikken. Prøv igjen senere",
    "equipment.equipment": "enheter",
    "equipment.search equipment": "søk etter enhet",
    "equipment.add equipment": "legg til enhet",
    "equipment.update equipment": "oppdater enhet",
    "equipment.plus equipment": "+ enhet",
    "equipment.Procurar equipamento": "Søk etter enhet",
    "equipment.EQUIPAMENTOS": "ENHETER",
    "equipment.Atualizar equipamento": "Oppdater enhet",
    "equipment.Atualizar equipamentos": "Oppdater enheter",
    "equipment.confirmar": "bekreft",
    "equipment.Selecione os modelos que deseja atualizar:": "Velg modellene du vil oppdatere:",
    "equipment.Como deseja realizar a atualização?": "Hvordan vil du utføre oppdateringen?",
    "equipment.Enviar atualização pela plataforma (internet)": "Send oppdatering via plattformen (internett)",
    "equipment.Salvar arquivo de atualização no dispositivo": "Lagre oppdateringsfil på enheten",
    "equipment.Linha Express": "Express-serien",
    "equipment.Escolha como deseja realizar a atualização": "Velg hvordan du vil utføre oppdateringen",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Velg minst én enhetsmodell som skal oppdateres",
    "equipment.Status: ": "Status: ",
    "equipment.Número de série:": "Serienummer:",
    "equipment.Menu:": "Meny:",
    "equipment.Status:": "Status:",
    "equipment.Número de série": "Serienummer",
    "equipment.Menu": "Meny",
    "equipment.Loja: ": "Butikk: ",
    "equipment.End:": "Adr.: ",
    "equipment.Endereço:": "Adresse: ",
    "equipment.Cidade:": "By: ",
    "equipment.CEP:": "Postnummer: ",
    "equipment.Atualização de software enviada com sucesso!": "Programvareoppdateringen ble sendt!",
    "equipment.Não foi possível enviar a atualização de software. Tente novamente mais tarde": "Kunne ikke sende programvareoppdateringen. Prøv igjen senere",
    "equipment.Download realizado com sucesso": "Nedlastingen ble fullført!",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "Kunne ikke laste ned. Prøv igjen senere",
    "equipment.Solicitação processada com erro. Tente novamente mais tarde": "Forespørselen ble behandlet med en feil. Prøv igjen senere",
    "equipment.Preencha o nome da versão": "Fyll inn versjonsnavnet",
    "equipment.Informe aqui todas as alterações desta nova versão": "Oppgi alle endringene i denne nye versjonen her",
    "equipment.Nova versão de software atualizada com sucesso!": "Den nye programvareversjonen ble oppdatert!",
    "equipment.Informe pelo menos uma mudança nesta versão": "Oppgi minst én endring i denne versjonen",
    "equipment.Falha ao transformar o arquivo em Blob": "Kunne ikke konvertere filen til Blob",
    "equipment.Erro ao criar Blob a partir do arquivo": "Feil ved opprettelse av Blob fra filen",
    "equipment.Falha ao ler o arquivo": "Kunne ikke lese filen",
    "equipment.selecionar tipo": "velg type",
    "equipment.selecione o tipo da versão": "velg versjonstype",
    "equipment.atualização": "OPPDATERING",
    "equipment.Selecione abaixo o que deseja fazer:": "Velg nedenfor hva du vil gjøre:",
    "equipment.Atualizar meus equipamentos": "Oppdater enhetene mine",
    "equipment.Enviar atualização para usuários selecionados": "Send oppdatering til valgte brukere",
    "equipment.ENVIAR": "SEND",
    "equipment.ENVIAR ATUALIZAÇÃO": "ENVIAR ATUALIZAÇÃO",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Selecione os e-mails para os quais deseja enviar a atualização:",
    "equipment.A atualização disponibilizada no dia": "A atualização disponibilizada no dia ",
    "equipment.referente ao equipamento": "referente ao equipamento ",
    "equipment.contempla o seguinte:": "contempla o seguinte:",
    "equipment.Selecionar arquivo para envio": "Selecionar arquivo para envio",
    "equipment.Por favor, selecione um arquivo .tar": "Por favor, selecione um arquivo .tar",
    "equipment.Selecione o modelo do equipamento:": "Selecione o modelo do equipamento:",
    "equipment.Selecione uma opção": "Selecione uma opção",
    "equipment.Nomeie a versão": "Nomeie a versão",
    "equipment.Clique sobre o arquivo que deseja baixar:": "Clique sobre o arquivo que deseja baixar:",
    "equipment.Baixar atualização": "Baixar atualização",
    "equipment.Versões": "Versões",
    "equipment.e superiores": "e superiores",
    "equipment.name": "nome",
    "equipment.model": "modelo",
    "equipment.category": "categoria",
    "equipment.store": "loja",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "e",
    "equipment.Últimas versões de software:": "Últimas versões de software: ",
    "equipment.Você não possui nenhum equipamento desatualizado": "Você não possui nenhum equipamento desatualizado",
    "equipment.grupos": "grupos",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "Não foi possível carregar os grupos de equipamentos da companhia",
    "equipment.vinculado ao grupo": "Vinculado ao grupo",
    "equipment.selecione um grupo": "Selecione um grupo",
    "equipment.cadastrar grupo": "Registrer gruppe",
    "equipment.Número de Série": "SN",
    "equipment.Versão": "Versjon",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "Kunne ikke registrere enheten. Velg eller registrer en gruppe",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "OPPRETT ENHETSGRUPPER!",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "For at brukerne som er knyttet til kontoen skal kunne se enhetene, må du:",
    "equipment.1) Criar grupo(s);": "1) Opprette gruppe(r);",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Tilordne enhet(er) til gruppen;",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) Tilordne bruker(e) til gruppen.",
    "equipment.Status software": "Programvarestatus",
    "equipment.Status menu": "Menystatus",
    "equipment.Pendente": "Venter",
    "equipment.Aceito": "Godkjent",
    "equipment.Recusado": "Avvist",
    "equipment.Atualizar software": "Oppdater programvare",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "Vil du sende oppdateringen til den valgte enheten?",
    "equipment.Companhia": "Selskap",
    "equipment.Exportar menu": "Eksporter meny",
    "equipment.companhias": "selskaper",
    "equipment.Nome da companhia": "Selskapsnavn",
    "equipment.Procurar equipamento, usuário ou companhia": "Søk etter enhet, bruker eller selskap",
    "equipment.Versão da power": "Power-versjon",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "DET FINNES ENNÅ INGEN OPPSKRIFTSDATA HER :(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "DET FINNES ENNÅ INGEN RENGJØRINGSDATA HER :(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "DET FINNES ENNÅ INGEN HENDELSESDATA HER :(",
    "ID": "ID",
    "equipment.Hora": "Klokkeslett",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "MEST FOREKOMMENDE HENDELSER PÅ ENHETEN I PERIODEN",
    "equipment.hour": "t",
    "equipment.minutes": "min",
    "equipment.date format": "DD/MM/ÅÅÅÅ",
    "equipment.preparada": "tilberedt",
    "equipment.vezes": "ganger",
    "equipment.vez": "gang",
    "equipment.Ver": "Vis",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "Dataene oppbevares av plattformen så lenge det er nødvendig for support, vedlikehold og videreutvikling av produktene.",
    "equipment.Ligado": "På",
    "equipment.Desligado": "Av",
    "equipment.CAN ERROR": "CAN-feil",
    "equipment.CAMERA SENSOR ERROR": "Feil på kammersensor",
    "equipment.STEAM/RI SENSOR ERROR": "Feil på damp-/RI-sensor",
    "equipment.PROBE 1 ERROR": "Feil på føler 1",
    "equipment.PROBE 2 ERROR": "Feil på føler 2",
    "equipment.PROBE 3 ERROR": "Feil på føler 3",
    "equipment.PROBE 4 ERROR": "Feil på føler 4",
    "equipment.PROBE 5 ERROR": "Feil på føler 5",
    "equipment.PROBE 6 ERROR": "Feil på føler 6",
    "equipment.GENERAL PROBE ERROR": "Generell følerfeil",
    "equipment.WATER LACK ERROR": "Feil: manglende vann",
    "equipment.HIGH PANEL TEMPERATURE ERROR": "Feil: høy paneltemperatur",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "Generell feil på frekvensomformer",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Kommunikasjonsfeil på frekvensomformer",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "Statusfeil på frekvensomformer",
    "equipment.CLEANING NOT COMPLETED ERROR": "Feil: rengjøring ikke fullført",
    "equipment.MAGNETRON ERROR": "Magnetronfeil",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Feil i enhetsfamilie/-modell",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "Feil på temperaturføler på kretskort",
    "equipment.ENERGY MODULE ERROR": "Feil i energimodul",
    "equipment.POWER BOARD I2C BUS ERROR": "I2C-bussfeil på power-kort",
    "equipment.GAS SYSTEM ERROR": "Gassystemfeil",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Feil: svært høy paneltemperatur",
    "equipment.POWER ON": "På",
    "equipment.POWER OFF": "Av",
    "equipment.DOOR OPENED": "Dør åpnet",
    "equipment.DOOR CLOSED": "Dør lukket",
    "equipment.CLEANING CANCELED ERROR": "Rengjøring avbrutt av bruker",
        "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "PIN ble ikke funnet. Kontroller og prøv igjen",
        "equipment.Ultracongeladores": "Hurtignedkjølere",
        "equipment.PIN já vinculado a outra conta": "PIN-koden er allerede knyttet til en annen konto",
        "equipment.Equipamento já cadastrado nesta conta": "Utstyret er allerede registrert på denne kontoen",
        "equipment.Não foi possível validar o PIN. Tente novamente": "PIN-koden kunne ikke valideres. Prøv igjen",
        "equipment.Modelo definido pelo equipamento": "Definert av utstyret",
        "equipment.Número de série offline inválido": "Skriv inn sju sifre uten mellomrom eller innledende null",
        "equipment.Número de série já cadastrado": "Serienummeret er allerede registrert",
    "equipment.Online": "På",
    "equipment.Offline": "Av",
    "equipment.Exibir apenas eventos": "Vis kun hendelser",
    "equipment.Endereço": "Adresse",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "Enheten er koblet til plattformen",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "Enheten er koblet fra plattformen",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "Meny fra plattformen godkjent av brukeren",
    "equipment.MENU REJECTED BY THE USER": "Meny fra plattformen avvist av brukeren",
    "equipment.CONNECTED TO THE INTERNET": "Koblet til internett",
    "equipment.DISCONNECTED FROM THE INTERNET": "Frakoblet internett",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Dessverre finnes det ingen kompatible versjoner for denne enheten som støtter sending av data.",
    "equipment.O equipamento": "Enheten",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "må oppdateres til den nyeste programvareversjonen for å kunne sende data til plattformen",
    "equipment.Versão do seu equipamento": "Enhetens versjon",
    "equipment.Versão disponível": "Tilgjengelig versjon",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Velg nedenfor hvordan du vil sende oppdateringen til enheten",
    "equipment.Salvar no dispositivo": "Lagre på enheten",
    "equipment.Enviar pela internet": "Send via internett",
    "equipment.Cliente": "Kunde",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "SERIENUMMER IKKE FUNNET",
    "equipment.BUSCAR": "SØK",
    "equipment.ACESSADOS RECENTEMENTE": "SIST ÅPNET",
    "equipment.SEM BUSCAS RECENTES": "INGEN NYLIGE SØK",
    "equipment.description.SEM BUSCAS RECENTES": "Bruk serienummeret for å søke etter enheter.",
    "equipment.Procurar equipamento pelo número de série": "Søk etter enhet med serienummer",
    "equipment.AIR FILTER CLEANING COMPLETED": "Rengjøring av luftfilter fullført",
    "equipment.AIR FILTER CLEANING REJECTED": "Rengjøring av luftfilter avvist",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "Rengjøring av katalytisk filter fullført",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "Rengjøring av katalytisk filter avvist",
    "equipment.Endereço (rua, avenida, rodovia)": "Adresse (gate, aveny, vei)",
    "equipment.Nº/Km": "Nr./Km",
    "equipment.ID do equipamento": "Enhets-ID",
    "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "Alle enheter må være knyttet til en gruppe. Velg en gruppe fra listen eller opprett en ny ved å klikke på + Registrer gruppe.",
    "equipment.Nomeie seu forno": "Gi ovnen et navn",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "For å vise PIN-koden, gå til IOK Virtual Platform i enhetens innstillinger.",
    "equipment.Vinculação IOK": "IOK-tilkobling",
   "equipment.Preparações": "Tilberedninger",
    "equipment.recipeTable.recipe": "Oppskrift",
    "equipment.recipeTable.origin": "Oppr.",
    "equipment.recipeTable.executions": "Utf.",
    "equipment.recipeTable.lastExecution": "Siste utførelse",
    "equipment.Última preparação": "Siste tilberedning",
    "equipment.localização": "plassering",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "DET FINNES ENNÅ INGEN REGISTRERTE PLASSERINGER :(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Klikk på knappen øverst til høyre for å legge til plasseringer.",
    "equipment.Procurar empresa ou local": "Søk etter selskap eller sted",
    "equipment.Adicionar localização": "Legg til plassering",
    "equipment.Adicionar": "Legg til",
    "equipment.espaço": "Område",
    "equipment.local": "Sted",
    "equipment.EXCLUIR LOCALIZAÇÃO": "SLETT PLASSERING",
    "equipment.Você deseja excluir esta localização?": "Vil du slette denne plasseringen?",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "Hvis du gjør dette, vil enhetene som er knyttet til denne plasseringen ikke lenger vise noen plassering. Du må angi et nytt sted for dem.",
    "equipment.Localização deletada com sucesso!": "Plasseringen ble slettet!",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Feil ved sletting av plasseringen. Prøv igjen senere",
    "equipment.Não foi possivel deletar a localização": "Kunne ikke slette plasseringen",
    "equipment.Localização adicionada com sucesso!": "Plasseringen ble lagt til!",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "Kunne ikke legge til plasseringen. Prøv igjen senere",
    "equipment.Nome do espaço": "Navn på område",
    "equipment.Informe o nome do espaço": "Oppgi navnet på området",
    "equipment.Preencha o nome do espaço": "Fyll inn navnet på området",
    "equipment.país": "Land",
    "equipment.informe o país": "Oppgi landet",
    "equipment.preencha o país": "Fyll inn landet",
    "equipment.Localização editada com sucesso!": "Plasseringen ble oppdatert!",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "Kunne ikke redigere plasseringen. Prøv igjen senere",
    "equipment.Editar localização": "Rediger plassering",
    "equipment.Pico de preparações": "Topp i tilberedninger",
    "equipment.informações da semana": "ukens informasjon",
    "equipment.horários de pico": "toppperioder",
    "equipment.horário de pico": "toppperiode",
    "equipment.preparações do dia": "dagens tilberedninger",
    "equipment.Horário": "Tid",
    "equipment.dia selecionado": "valgt dag",
    "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "Riktig og daglig rengjøring av ovnen bidrar til korrekt drift og påvirker garantien.",
    "equipment.Total de limpezas realizadas:": "Totalt antall utførte rengjøringer:",
    "equipment.Limpezas não concluídas:": "Ikke fullførte rengjøringer:",
    "equipment.Desde a vinculação do forno a IOK": "Siden ovnen ble koblet til IOK",
    "equipment.Equipamento ligado há:": "Enheten har vært på i:",
    "equipment.Total de receitas preparadas:": "Totalt antall tilberedte oppskrifter:",
    "equipment.Receitas preparadas": "Tilberedte oppskrifter",
    "equipment.Aberturas de porta": "Døråpninger",
    "equipment.Desde a última vez que o forno foi ligado": "Siden ovnen sist ble slått på",
    "equipment.Preparação": "Tilberedning",
    "equipment.Nenhuma localização criada": "Ingen plassering opprettet",
    "equipment.Acesso remoto": "Fjerntilgang",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Oppgi ID-en til selskapet som skal kunne få fjerntilgang til ovnen din. Bruk ; for å skille ID-er.",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "Fjerntilgang gjør det mulig for de valgte selskapene å sende menyer og oppdateringer til enheten din.",
    "equipment.Concedo acesso remoto à Prática oficial.": "Jeg gir fjerntilgang til Prática Official.",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "Vil du velge andre enheter som er knyttet til kontoen din for å gi dem fjerntilgang?",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Velg nedenfor enhetene du vil gi fjerntilgang til",
    "equipment.Acesso remoto concedido com sucesso!": "Fjerntilgang ble gitt!",
    "equipment.Selecione pelo menos um equipamento": "Velg minst én enhet",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "Kunne ikke redigere enhetene. Prøv igjen senere",
    "equipment.Solicitar atendimento": "Be om service",
    "equipment.Relate um problema": "Rapporter et problem",
    "equipment.Descreva aqui o problema de seu equipamento": "Beskriv problemet med enheten din her",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "Kunne ikke sende serviceforespørselen din. Prøv igjen senere",
    "equipment.Solicitação técnica enviada com sucesso!": "Den tekniske forespørselen ble sendt!",
    "equipment.Enviar": "Send",
    "equipment.Solicitação de atendimento": "Serviceforespørsel",
    "equipment.Informe o problema de seu equipamento": "Beskriv problemet med enheten din",
    "equipment.Informações do magnetron": "Magnetroninformasjon",
    "equipment.Vida útil aproximada": "Omtrentlig levetid",
    "equipment.MAGNETRON USAGE HOURS": "Brukstimer for magnetron",
    "equipment.Atendimento": "Service",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "Hyppigste hendelser på enheten i perioden",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "ENHET UTEN SERIENUMMER",
    "equipment.Filtros": "Filtre",
    "equipment.Filtrar": "Filtrer",
    "equipment.Limpar filtros": "Fjern filtre",
    "equipment.Procurar por modelo, versão ou país": "Søk etter modell, versjon eller land",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "Søk etter enhet, SN, modell, versjon eller land",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "Følgende ID-er tilhører ikke et selskap av typen «Distributør» og ble fjernet",
    "equipment.BAIXAR VERSÕES": "LAST NED VERSJONER",
    "equipment.Compatível com todas as versões da IHM.": "Kompatibel med alle IHM-versjoner.",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Kun kompatibel med Power-versjon 2.0.0C.",
    "equipment.Procurar evento": "Søk etter hendelse",
    "equipment.Forno conectado": "Tilkoblet ovn",
    "equipment.Limpeza de filtro de ar": "Rengjøring av luftfilter",
    "equipment.Limpeza de filtro catalítico": "Rengjøring av katalytisk filter",
    "equipment.Limpeza realizada": "Rengjøring utført",
    "equipment.Limpeza recomendada": "Anbefalt rengjøring",
    "equipment.Forno ligado": "Ovn på",
    "equipment.Inversor de frequência": "Frekvensomformer",
    "equipment.Temperatura de painel": "Paneltemperatur",
    "equipment.Sensor da câmara": "Kammersensor",
    "equipment.Magnetron": "Magnetron",
    "equipment.Power": "Power",
    "equipment.Informações de menu": "Menyinformasjon",
    "equipment.Limpeza": "Rengjøring",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "Enheten bruker allerede den nyeste programvareversjonen.",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Merk: Beregningen av magnetronens levetid tar ikke hensyn til brukstid før versjon F1.1.0.",
    "equipment.Equipamentos com erro": "Enheter med feil",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.":
    "Snart vil du få tilgang til viktige data sendt fra ovnen, som perioder med høyest bruk, mest tilberedte oppskrifter, rengjøringshistorikk, registrerte hendelser og mye mer! Husk å holde enheten oppdatert med de nyeste versjonene som er tilgjengelige på plattformen.",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.":
    "For at rengjøringen skal registreres på enheten og sendes til plattformen, må hele rengjøringsprosedyren på ovnen følges trinn for trinn. Det er ikke nødvendig å se videoene for hvert trinn, når de er tilgjengelige.",
    "equipment.Horas de uso": "Brukstimer",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "Registreringen av magnetronens brukstimer er tilgjengelig fra versjon F1.0.6.",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "Programvareoppdateringen tar omtrent 15 minutter. Under prosessen vil ovnen starte på nytt og vise en blå skjerm til oppdateringen er fullført. For å unngå feil må ovnen være slått på og koblet til internett. Hvis du velger å oppdatere via USB-minne, må du ikke fjerne det før oppdateringen er fullført.",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "Enheten {name} med programvare {version} må oppdateres via USB. Programvareoppdateringen tar omtrent 15 minutter. Under prosessen vil ovnen starte på nytt og vise en blå skjerm til oppdateringen er fullført. For å unngå feil må ovnen være slått på og koblet til internett. Hvis du velger å oppdatere via USB-minne, må du ikke fjerne det før oppdateringen er fullført.",
    "equipment.Observação": "Merk:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "For versjoner ST2.0.0 og nyere vil oppdateringer via plattformen (Wi-fi) fortsatt være tilgjengelige som normalt.",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Her finner du generell informasjon om enheten;",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "Ved å klikke på disse knappene kan du be om service for ovnen og eksportere dataene til Excel-regneark;",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "I feltene nedenfor finner du detaljert informasjon om tilberedning av oppskrifter;",
    "equipment.Horário de pico;": "Toppperiode;",
    "equipment.Informações referentes a higienização;": "Informasjon om rengjøring;",
    "equipment.E histórico de eventos;": "Og hendelseshistorikk;",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Husk at du må velge perioden du ønsker å se data for. Dette kan du gjøre ved å klikke på kalenderen i panelene og ved å velge filtre.",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "Laster ned filen... Den vil snart være tilgjengelig!",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "Registreringen av magnetronens brukstimer er tilgjengelig fra versjon F1.1.0.",
    "equipment.Data de fabricação": "Produksjonsdato",
    "equipment.manutenção": "vedlikehold",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.":
    "Når du søker etter og finner et serienummer, opprettes en midlertidig forbindelse direkte med ovnen, slik at vedlikeholdsdata kan deles. Disse dataene lagres ikke på plattformen, og et nytt søk må utføres hver gang du ønsker tilgang til dem.",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "OPPGI ET SERIENUMMER OG KLIKK PÅ SØK",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.":
    "Kun modellene FIT Express / FIT Single Mag / FIT XL med programvareversjon F2.1.0 vil sende vedlikeholdsdata. Informasjonen, spesielt tellerverdiene, vil bli registrert fra og med denne versjonen.",
    "equipment.Procurar número de série": "Søk etter serienummer",
    "equipment.ENCERRAR SESSÃO": "AVSLUTT ØKT",
    "equipment.Alerta": "Varsel",
    "equipment.Local": "Sted",
    "equipment.Software": "Programvare",
    "equipment.Forno sem limpeza há": "Ovn uten rengjøring i",
    "equipment.Horário de pico": "Toppperiode",
    "equipment.HP": "HP",
    "equipment.RECIPE STARTED": "Oppskrift startet",
    "equipment.RECIPE CANCELED": "Oppskrift avbrutt av brukeren",
    "equipment.RECIPE COMPLETED": "Oppskrift fullført",
    "equipment.DOOR OPENED RECIPE": "Dør åpnet under oppskriften",
    "equipment.DOOR CLOSED RECIPE": "Dør lukket under oppskriften",
    "equipment.Receitas iniciadas": "Startede oppskrifter",
    "equipment.Receitas concluídas": "Fullførte oppskrifter",
    "equipment.Receitas interrompidas": "Avbrutte oppskrifter",
    "equipment.Total de receitas concluídas:": "Totalt antall fullførte oppskrifter:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "TOTALT ANTALL AVBRUTTE OPPSKRIFTER",
    "equipment.DOWNLOAD_PROGRESS": "LASTER NED FIL... VENT, FREMDRIFT: {progress}%",
    "equipment.Informe o número de série do forno": "Oppgi ovnens serienummer",
    "equipment.preencha o número de série do forno": "Fyll inn ovnens serienummer",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "SERIENUMMER IKKE REGISTRERT",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "Serienummeret ble ikke funnet. Kontroller og prøv igjen",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "Før du starter oppdateringen, må du sikkerhetskopiere oppskriftene som er lagret på enheten for å sikre dataintegriteten. Sikkerhetskopien kan opprettes via USB-minne eller gjennom plattformen. Dette gjør det mulig å gjenopprette informasjonen ved datatap.",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Meny mottatt fra plattformen via tvungen oppdatering",
    "equipment.Nome da receita não encontrado": "Oppskriftsnavn ikke funnet",
    "equipment.passos": "{count, plural, one {trinn} other {trinn}}",
    "equipment.minAbbreviation": "min",
    "equipment.secAbbreviation": "sek",
    "equipment.Configurações": "Innstillinger",
    "equipment.Tempo de preaquecimento": "Forvarmingstid",
    "equipment.Formato de data": "Datoformat",
    "equipment.Formato de hora": "Tidsformat",
    "equipment.Unidade de temperatura": "Temperaturenhet",
    "equipment.Aquecer/dourar mais": "Varm opp/brun mer",
    "equipment.Fabricante": "Produsent",
    "equipment.Voltagem": "Spenning",
    "equipment.Introdução": "Introduksjon",
    "equipment.Modelo": "Modell",
    "equipment.Motor": "Motor",
    "equipment.Hostname": "Vertsnavn",
    "equipment.STATUS DA OPERAÇÃO": "OPERASJONSSTATUS",
    "equipment.ÚLTIMA LIMPEZA": "SISTE RENGJØRING",
    "equipment.VELOCIDADE DO MOTOR": "MOTORHASTIGHET",
    "equipment.TENSÃO ATUAL": "AKTUELL SPENNING",
    "equipment.Sensores e periféricos": "Sensorer og eksterne enheter",
    "equipment.Contadores": "Tellere",
    "equipment.HORAS DE USO DO MOTOR": "MOTORENS BRUKSTIMER",
    "equipment.HORAS DE USO DO MAGNETRON": "MAGNETRONENS BRUKSTIMER",
    "equipment.ABERTURAS DE PORTA": "DØRÅPNINGER",
    "equipment.ATUAÇÃO DO RELE DA POWER": "AKTIVERINGER AV POWER-RELÉ",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "AKTIVERINGER AV DØRSENSOR",
    "equipment.RECEITAS EXECUTADAS": "UTFØRTE OPPSKRIFTER",
    "equipment.LIMPEZAS EXECUTADAS": "UTFØRTE RENGJØRINGER",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "BRUKSTIMER FOR KATALYTISK FILTER",
    "equipment.HORAS DE USO DO FILTRO DE AR": "BRUKSTIMER FOR LUFTFILTER",
    "equipment.CORRENTE DO MAGNETRON": "MAGNETRONSTRØM",
    "equipment.Erros": "Feil",
    "equipment.status online": "online-status",
    "equipment.status offline": "offline-status",
    "equipment.software accepted": "programvare godkjent",
    "equipment.menu accepted": "meny godkjent",
    "equipment.software pending": "programvare venter",
    "equipment.menu pending": "meny venter",
    "equipment.software refused": "programvare avvist",
    "equipment.menu refused": "meny avvist",
    "equipment.Ativado": "Aktivert",
    "equipment.Desativado": "Deaktivert",
    "equipment.Cozinhando": "Tilbereder",
    "equipment.Pré-aquecendo": "Forvarmer",
    "equipment.Em espera": "I ventemodus",
    "equipment.Limpando": "Rengjør",
    "equipment.horas": "timer",
    "equipment.Erro CAN": "CAN-feil",
    "equipment.Erro no sensor de câmara": "Feil på kammersensor",
    "equipment.Alerta de temperatura alta no painel": "Varsel om høy paneltemperatur",
    "equipment.Erro de temperatura alta no painel": "Feil: høy paneltemperatur",
    "equipment.Alerta de comunicação no inversor de frequência": "Kommunikasjonsvarsel for frekvensomformer",
    "equipment.Alerta de status no inversor de frequência": "Statusvarsel for frekvensomformer",
    "equipment.Alerta na corrente do magnetron": "Varsel om magnetronstrøm",
    "equipment.Erro no modelo do equipamento": "Feil i enhetsmodell",
    "equipment.Erro no módulo de energia": "Feil i energimodul",
    "equipment.Erro I2C": "I2C-feil",
    "equipment.Erro de temperatura alta na placa": "Feil: høy temperatur på kretskort",
    "equipment.Fechado": "Lukket",
    "equipment.Aberto": "Åpen",
    "equipment.Câmara": "Kammer",
    "equipment.Placa": "Kretskort",
    "equipment.Tensão": "Spenning",
    "equipment.Corrente da placa": "Strøm på kretskort",
    "equipment.Velocidade do motor": "Motorhastighet",
    "equipment.Rele da resistência": "Varmeelementrelé",
    "equipment.Rele de curto circuito": "Kortslutningsrelé",
    "equipment.Ventilador radial": "Radialvifte",
    "equipment.Led vermelho": "Rød LED",
    "equipment.Led verde": "Grønn LED",
    "equipment.Led azul": "Blå LED",
    "equipment.Erro": "Feil",
    "equipment.Sensor": "Sensor",
    "equipment.Valor": "Verdi",
    "equipment.Manutenção da temperatura": "Temperaturvedlikehold",
    "equipment.Manutenção": "Vedlikehold",
    "equipment.Esfriando": "Kjøler ned",
    "equipment.CEILING SENSOR ERROR": "Feil på taksensor",
    "equipment.BALLAST SENSOR ERROR": "Feil på lastrosensor",
    "equipment.VAPORIZER SENSOR ERROR": "Feil på dampgeneratorsensor",
    "equipment.EQUIPMENT CONSUMPTION": "Forbruk",
    "equipment.Sensores": "Sensorer",
    "equipment.Falta de água": "Mangel på vann",
    "equipment.Executando Receita": "Tilbereder oppskrift",
    "equipment.Executando Limpeza": "Utfører rengjøring",
    "equipment.Dia": "Dag",
    "equipment.Semana": "Uke",
    "equipment.Mês": "Måned",
    "equipment.Tempo": "Tid",
    "equipment.Segunda": "Mandag",
    "equipment.Terça": "Tirsdag",
    "equipment.Quarta": "Onsdag",
    "equipment.Quinta": "Torsdag",
    "equipment.Sexta": "Fredag",
    "equipment.Sábado": "Lørdag",
    "equipment.Domingo": "Søndag",
    "equipment.CONSUMO ESTIMADO": "ESTIMERT FORBRUK",
    "equipment.CONSUMO ATUAL": "AKTUELT FORBRUK",
    "equipment.ECONOMIA COM MODO ECO": "BESPARELSE MED ØKO-MODUS",
    "equipment.MÉDIA SEMANAL": "UKENTLIG GJENNOMSNITT",
    "equipment.MÉDIA MENSAL": "MÅNEDLIG GJENNOMSNITT",
    "equipment.Consumo de energia": "Energiforbruk",
    "equipment.CONSUMO ACUMULADO": "AKKUMULERT FORBRUK",
    "equipment.MÉDIA DIÁRIA": "DAGLIG GJENNOMSNITT",
    "equipment.mês selecionado": "valgt måned",
    "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "Denne verdien representerer summen av energiforbruket for hver time i løpet av dagen.",
    "equipment.Este valor representa a soma total dos consumos de cada dia.": "Denne verdien representerer summen av energiforbruket for hver dag.",
    "equipment.Este valor representa a soma total dos consumos de cada semana.": "Denne verdien representerer summen av energiforbruket for hver uke.",
    "equipment.Este valor representa a soma total dos consumos de cada mês.": "Denne verdien representerer summen av energiforbruket for hver måned.",
    "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "Denne verdien representerer gjennomsnittlig energiforbruk per time og gir dermed et estimat basert på bruken.",
    "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "Denne verdien representerer gjennomsnittlig energiforbruk per dag og gir dermed et estimat basert på bruken.",
    "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "Denne verdien representerer gjennomsnittlig ukentlig energiforbruk og gir dermed et estimat basert på bruken.",
    "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "Denne verdien representerer gjennomsnittlig energiforbruk de siste to månedene og gir dermed et estimat basert på bruken.",
    "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "Denne verdien representerer den totale energibesparelsen per time ved bruk av Eco-modus.",
    "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "Denne verdien representerer den totale energibesparelsen per dag ved bruk av Eco-modus.",
    "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "Denne verdien representerer den totale ukentlige energibesparelsen ved bruk av Eco-modus.",
    "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "Denne verdien representerer den totale månedlige energibesparelsen ved bruk av Eco-modus.",
    "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "Denne verdien representerer gjennomsnittlig energiforbruk de siste 7 dagene, uten å inkludere dagens forbruk.",
    "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "Denne verdien representerer gjennomsnittlig energiforbruk de siste 4 ukene.",
    "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "Denne verdien representerer gjennomsnittlig energiforbruk de siste 2 månedene, uten å inkludere inneværende måned.",
    "equipment.Lista de consumo de energia": "Liste over energiforbruk",
    "equipment.Período": "Periode",
    "equipment.Consumo (kWh)": "Forbruk (kWh)",
    "equipment.Economia com ECO (kWh)": "Besparelse med ECO (kWh)",
    "equipment.Total": "Totalt",
    "equipment.Sensor de RI": "RI-sensor",
    "equipment.HUMIDITY SENSOR ERROR": "Feil på fuktighetssensor",
    "equipment.TEMPERATURE SENSOR ERROR": "Feil på temperatursensor",
    "equipment.WATER FILTER CLEANING COMPLETED": "Bytte av vannfilter fullført",
    "equipment.WATER FILTER CLEANING REJECTED": "Bytte av vannfilter avvist",
    "equipment.HOOD TURNED ON": "Avtrekkshette slått på",
    "equipment.HOOD TURNED OFF": "Avtrekkshette slått av",
    "equipment.AUTOMATIC PREHEATING REJECTED": "Automatisk forvarming avvist",
    "equipment.Receitas Forno": "Ovnsoppskrifter",
    "equipment.Receitas Fermentadora": "Heveskapsoppskrifter",
        "equipment.média diária": "daglig gjennomsnitt",
        "equipment.média de execução diária": "gjennomsnittlig antall daglige kjøringer",
    "equipment.FERMENTADORA": "HEVESKAP",
    "equipment.FORNO": "OVN",
    "equipment.DIA": "DAG",
    "equipment.Baixado": "Lastet ned",
    "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia.": "Daglig rengjøring av enheten bidrar til korrekt drift og påvirker garantien.",
    "equipment.Desde a vinculação do equipamento ao IOK": "Siden enheten ble koblet til IOK",
    "equipment.Total desde a vinculação do equipamento ao IOK": "Totalt siden enheten ble koblet til IOK",
    "equipment.Receitas do forno": "Ovnsoppskrifter",
    "equipment.Receitas da fermentadora": "Heveskapsoppskrifter",
    "equipment.FERM.": "HEV.",
    "equipment.Fermentadora": "Heveskap",
    "equipment.Coifa": "Avtrekkshette",
    "equipment.Preaquecimento automático": "Automatisk forvarming",
    "equipment.nivel": "nivå",
    "equipment.Fermentadora ligada": "Heveskap slått på",
    "equipment.Fermentadora desligada": "Heveskap slått av",
    "equipment.Forno desligado": "Ovn slått av",
    "equipment.Equipamento ligado": "Enhet slått på",
    "equipment.Equipamento desligado": "Enhet slått av",
    "equipment.visualizar haccp": "vis HACCP",
    "equipment.HACCP": "HACCP",
    "equipment.Atualizar Equip.": "Oppdater enhet",
    "equipment.Consumo de agua por receita": "Vannforbruk per oppskrift",
    "equipment.Consumo de energia por receita": "Energiforbruk per oppskrift",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "DET FINNES ENNÅ INGEN DATA OM VANNFORBRUK PER OPPSKRIFT :(",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "DET FINNES ENNÅ INGEN DATA OM ENERGIFORBRUK PER OPPSKRIFT :(",
    "equipment.LITROS CONSUMIDOS NO DIA": "LITER FORBRUKT I DAG",
    "equipment.ENERGIA CONSUMIDA NO DIA": "ENERGI FORBRUKT I DAG",
    "equipment.CONSUMO ACUMULADO SEMANAL": "AKKUMULERT UKENTLIG FORBRUK",
    "equipment.CONSUMO ACUMULADO MENSAL": "AKKUMULERT MÅNEDLIG FORBRUK",
    "equipment.Receitas": "Oppskrifter",
    "equipment.Consumo (L)": "Forbruk (L)",
    "equipment.Exec. dia - (L)": "Daglig tilberedning - (L)",
    "equipment.Exec. semana - (L)": "Ukentlig tilberedning - (L)",
    "equipment.Exec. mês - (L)": "Månedlig tilberedning - (L)",
    "equipment.Exec. dia - (kWh)": "Daglig tilberedning - (kWh)",
    "equipment.Exec. semana - (kWh)": "Ukentlig tilberedning - (kWh)",
    "equipment.Exec. mês - (kWh)": "Månedlig tilberedning - (kWh)",
    "equipment.Agua consumida (litros)": "Vannforbruk (liter)",
    "equipment.Energia consumida (kWh)": "Energiforbruk (kWh)",
    "equipment.temperatura da câmara": "Kammertemperatur",
    "equipment.temperatura do vapor": "Damptemperatur",
    "equipment.último evento listado": "Siste registrerte hendelse",
    "equipment.temperatura da sonda": "Følertemperatur",
    "equipment.porta": "Dør",
    "equipment.temperatura": "Temperatur",
    "equipment.temperatura atual": "Gjeldende temperatur",
    "equipment.média de oscilação diária": "Gjennomsnittlig daglig temperaturvariasjon",
    "equipment.oscilação diária da temperatura": "Daglig temperaturvariasjon",
    "equipment.temperature.sectionTitle": "Temperatur",
    "equipment.temperature.currentChamber": "GJELDENDE KAMMERTEMPERATUR:",
    "equipment.temperature.currentProbe": "GJELDENDE FØLERTEMPERATUR:",
    "equipment.temperature.currentSteam": "GJELDENDE DAMPTEMPERATUR:",
    "equipment.temperature.dailyOscillation": "Daglig temperaturvariasjon",
    "equipment.temperature.chamberShort": "Kammer",
    "equipment.temperature.probeShort": "Føler",
    "equipment.temperature.axisLabel": "Temperatur {unit}",
    "equipment.temperature.dailyAverage": "DAGLIG GJENNOMSNITT",
    "equipment.temperature.weeklyAverage": "UKENTLIG GJENNOMSNITT",
    "equipment.temperature.monthlyAverage": "MÅNEDLIG GJENNOMSNITT",
    "equipment.temperature.lastListedEvent": "Siste registrerte hendelse",
    "equipment.temperature.door": "Dør",
    "equipment.temperature.open": "ÅPEN",
    "equipment.temperature.closed": "LUKKET",
    "equipment.temperature.defineTimeRange": "Angi tidsintervall:",
    "equipment.temperature.until": "til",
    "equipment.cleaningType.smart": "Smart rengjøring",
    "equipment.cleaningType.light": "Lett rengjøring",
    "equipment.cleaningType.medium": "Middels rengjøring",
    "equipment.cleaningType.heavy": "Kraftig rengjøring",
    "equipment.cleaningType.decalcifying": "Avkalkingsrengjøring",
    "equipment.cleaningType.security": "Sikkerhetsrengjøring",
    "equipment.cleaningType.rinse": "Skylling",
    "equipment.cleaningType.custom": "Tilpasset rengjøring",
    "equipment.cleaningTypeShort.smart": "Smart",
    "equipment.cleaningTypeShort.light": "Lett",
    "equipment.cleaningTypeShort.medium": "Middels",
    "equipment.cleaningTypeShort.heavy": "Kraftig",
    "equipment.cleaningTypeShort.decalcifying": "Avkalking",
    "equipment.cleaningTypeShort.security": "Sikkerhet",
    "equipment.cleaningTypeShort.rinse": "Skylling",
    "equipment.cleaningTypeShort.custom": "Tilpasset",
    "equipment.gerar gráficos": "generer grafer",
    "equipment.Realizada": "Utført",
    "equipment.Recomendada": "Anbef.",
    "equipment.Dias da semana": "Ukedager",
    "equipment.Horário 24h": "24-timers klokke",
    "equipment.seg": "Man",
    "equipment.ter": "Tir",
    "equipment.qua": "Ons",
    "equipment.qui": "Tor",
    "equipment.sex": "Fre",
    "equipment.sab": "Lør",
    "equipment.dom": "Søn",
    "equipment.Desconhecido": "Ukjent",
    "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(": "DET FINNES ENNÅ INGEN DATA OM ENERGIFORBRUK HER :(",
    "equipment.monthShort.Jan": "Jan",
    "equipment.monthShort.Fev": "Feb",
    "equipment.monthShort.Mar": "Mar",
    "equipment.monthShort.Abr": "Apr",
    "equipment.monthShort.Mai": "Mai",
    "equipment.monthShort.Jun": "Jun",
    "equipment.monthShort.Jul": "Jul",
    "equipment.monthShort.Ago": "Aug",
    "equipment.monthShort.Set": "Sep",
    "equipment.monthShort.Out": "Okt",
    "equipment.monthShort.Nov": "Nov",
    "equipment.monthShort.Dez": "Des",
    "equipment.settingsChange.category": "Parameterendring",
    "equipment.settingsChange.factoryTitle": "Endring av teknisk parameter",
    "equipment.settingsChange.userTitle": "Endring av brukerparameter",
    "equipment.settingsChange.changedTo": "{label} endret til {value}",
    "equipment.settingsChange.hardResetExecuted": "Hard reset utført",
    "equipment.settingsChange.userFactoryResetExecuted": "Brukerens fabrikktilbakestilling utført",
    "equipment.settingsChange.magSensorEnabled": "magnetronsensor",
    "equipment.settingsChange.serialNumber": "serienummer",
    "equipment.settingsChange.manufactureDate": "produksjonsdato",
    "equipment.settingsChange.inverterType": "invertertype",
    "equipment.settingsChange.preHeatMotorSpeed": "motorhastighet for forvarming",
    "equipment.settingsChange.voltage": "spenning",
    "equipment.settingsChange.oemModeEnabled": "OEM-modus",
    "equipment.settingsChange.controlDoor": "dørkontroll",
    "equipment.settingsChange.hardReset": "Hard reset",
    "equipment.settingsChange.preHeatTemperatureOne": "forvarmingstemperatur 1",
    "equipment.settingsChange.preHeatTemperatureTwo": "forvarmingstemperatur 2",
    "equipment.settingsChange.preHeatTime": "forvarmingstid",
    "equipment.settingsChange.preHeatTwoEnabled": "forvarming 2",
    "equipment.settingsChange.userFactoryReset": "Brukerens fabrikktilbakestilling",
    "equipment.settingsChange.enableManualMode": "manuell modus",
    "equipment.settingsChange.enableFavorites": "favoritter",
    "equipment.settingsChange.enableHeatBrown": "varm opp/brun mer",
    "equipment.settingsChange.enableRepeatRecipe": "gjenta oppskrift",
    "equipment.settingsChange.enableOperatorMode": "operatørmodus",
    "equipment.settingsChange.enableAutoImport": "automatisk import",
    "equipment.settingsChange.enableRecipePreRunMessage": "melding før oppskriftskjøring",
    "equipment.settingsChange.controlDoorTwoInputs": "2 innganger",
    "equipment.settingsChange.controlDoorThreeInputs": "3 innganger",
    
    //LOJAS
    "store.Procurar loja": "Søk etter butikk",
    "store.Excluir": "Slett",
    "store.Editar": "Rediger",
    "store.nome": "Navn",
    "store.equipamentos": "Utstyr",
    "store.Equipamentos vinculados": "Tilknyttet utstyr",
    "store.cidade": "By",
    "store.estado": "Fylke",
    "store.salvar": "lagre",
    "store.cadastrar loja": "registrer butikk",
    "store.Nome fantasia": "Butikknavn",
    "store.Preencha o nome da loja": "Fyll inn butikkens navn",
    "store.CNPJ": "CNPJ",
    "store.Preencha o CNPJ da loja": "Fyll inn butikkens CNPJ",
    "store.CEP": "Postnummer",
    "store.Preencha o CEP da loja": "Fyll inn butikkens postnummer",
    "store.Informe o nome fantasia": "Oppgi butikknavnet",
    "store.Cidade": "By",
    "store.Informe a cidade": "Oppgi byen",
    "store.Preencha a cidade": "Fyll inn byen",
    "store.UF": "Fylke",
    "store.Preencha o UF da loja": "Fyll inn butikkens fylke",
    "store.Bairro": "Bydel",
    "store.Informe o bairro": "Oppgi bydelen",
    "store.Preencha o bairro da loja": "Fyll inn butikkens bydel",
    "store.Endereço": "Adresse",
    "store.Informe o endereço": "Oppgi adressen",
    "store.Preencha o endereço da loja": "Fyll inn butikkens adresse",
    "store.Nº": "Nr.",
    "store.Preencha o número": "Fyll inn nummeret",
    "store.Loja cadastrada com sucesso": "Butikken ble registrert",
    "store.Erro ao adicionar loja. Tente novamente":
    "Feil ved registrering av butikk. Prøv igjen.",
    "store.Loja deletada com sucesso": "Butikken ble slettet",
    "store.Erro ao deletar loja. Tente novamente mais tarde":
    "Feil ved sletting av butikk. Prøv igjen senere.",
    "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "DET FINNES ENNÅ INGEN REGISTRERTE BUTIKKER :(",
    "store.EXCLUIR LOJA": "SLETT BUTIKK",
    "store.Você deseja excluir a loja da plataforma IOK?": "Vil du slette butikken fra IOK-plattformen?",
    "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "Hvis du gjør dette, vil utstyret som er knyttet til butikken ikke lenger være tilknyttet noen butikk, med mindre du kobler det til igjen.",
    "store.loja editada com sucesso": "Butikken ble oppdatert",
    "store.não foi possível editar a loja. Tente novamente mais tarde": "Kunne ikke redigere butikken. Prøv igjen senere.",
    "store.editar loja": "rediger butikk",
    "store.Procurar grupo de equipamentos": "Søk etter utstyrsgruppe",
    "store.cadastrar grupo": "registrer gruppe",
    "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "DET FINNES ENNÅ INGEN REGISTRERTE GRUPPER :(",
    "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Klikk på knappen øverst til høyre for å legge til grupper.",
    "store.cadastrar grupo de equipamentos": "registrer utstyrsgruppe",
    "store.grupo de equipamentos cadastrado com sucesso!": "Utstyrsgruppen ble registrert!",
    "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "Kunne ikke registrere gruppen. Prøv igjen senere.",
    "store.Nome do grupo": "Gruppenavn",
    "store.informe o nome do grupo": "Oppgi gruppenavnet",
    "store.preencha o nome do grupo": "Fyll inn gruppenavnet",
    "store.Grupo de equipamentos deletado com sucesso!": "Utstyrsgruppen ble slettet!",
    "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Feil ved sletting av gruppen. Prøv igjen senere.",
    "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "SLETT UTSTYRSGRUPPE",
    "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "Vil du slette denne utstyrsgruppen fra IOK-plattformen?",
    "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "Hvis du gjør dette, vil utstyret som er knyttet til gruppen ikke lenger være tilknyttet noen gruppe, med mindre du kobler det til igjen.",
    "store.grupo de equipamentos editado com sucesso!": "Utstyrsgruppen ble oppdatert!",
    "store.não foi possível editar o grupo. Tente novamente mais tarde": "Kunne ikke redigere gruppen. Prøv igjen senere.",
    "store.editar grupo de equipamentos": "rediger utstyrsgruppe",
    "store.CEP não encontrado no Brasil": "Postnummer ikke funnet i Brasil",
    "store.Cadastrar": "Registrer",
    "store.Equipamentos vinculados": "Tilknyttet utstyr",
    
    // NAVBAR
    "navbar.home": "hjem",
    "navbar.cookbook": "cookbook",
    "navbar.my menus": "mine menyer",
    "navbar.equipment": "utstyr",
    "navbar.users": "brukere",
    "navbar.calls": "henvendelser",
    "navbar.settings": "innstillinger",
    "navbar.help": "hjelp",
    "navbar.logout": "Logg ut",
    "navbar.Editar conta": "Rediger konto",
    "navbar.API Externa": "Ekstern API",
    "navbar.companhias": "selskaper",
    "navbar.information": "IOK-informasjon",
    
    // FOOTERBAR
    "footerBar.menu": "Meny",
    "footerBar.cookbook": "Cookbook",
    "footerBar.home": "Hjem",
    "footerBar.menus": "Menyer",
    "footerBar.notifications": "Varsler",
    
    //ATENDIMENTOS
    "calls.ATENDIMENTOS EM ABERTO": "ÅPNE HENVENDELSER",
    "calls.ATENDIMENTOS ENCERRADOS": "AVSLUTTEDE HENVENDELSER",
    
    //MAP
    "map.título": "Plassering",
    "map.erro": "feil!",
    "map.mensagem de erro": "kunne ikke laste kartet.",
    "map.Localização não disponível": "Plassering ikke tilgjengelig",
    
    //MODAL
    "modal.CONFIRMAR": "BEKREFT",
    "modal.Salvar alterações": "Lagre endringer",
    "Modal.Há alterações não salvas nos parâmetros dos passos ":
    "Det finnes ulagrede endringer i trinnparametrene ",
    "Modal.Como deseja proceder?": "Hvordan vil du fortsette?",
    "Modal.Avaliar alterações realizadas": "Gjennomgå utførte endringer",
    "Modal.Descartar alterações": "Forkast endringer",
    
    //USUÁRIOS
    "user.Nome": "Navn",
    "user.E-mail": "E-post",
    "user.Permissão": "Tillatelse",
    "user.Loja": "Butikk",
    "user.Status": "Status",
    "user.Excluir": "Slett",
    "user.Editar": "Rediger",
    "user.Procurar usuário": "Søk etter bruker",
    "user.ADICIONAR USUÁRIO": "LEGG TIL BRUKER",
    "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "DET FINNES ENNÅ INGEN REGISTRERTE BRUKERE :(",
    "user.+ Usuário": "+ Bruker",
    "user.Informe o nome do usuário": "Oppgi brukerens navn",
    "user.Preencha o nome do usuário": "Fyll inn brukerens navn",
    "user.Informe o e-mail do usuário": "Oppgi brukerens e-postadresse",
    "user.Preencha com um e-mail válido": "Fyll inn en gyldig e-postadresse",
    "user.Administrador": "Administrator",
    "user.Usuário": "Bruker",
    "user.Preencha o telefone do usuário": "Fyll inn brukerens telefonnummer",
    "user.Selecione a permissão do usuário": "Velg brukerens tillatelse",
    "user.Ativo": "Aktiv",
    "user.Inativo": "Inaktiv",
    "user.Usuário deletado da plataforma com sucesso!": "Brukeren ble slettet fra plattformen!",
    "user.Ocorreu um erro. Tente novamente mais tarde": "Det oppstod en feil. Prøv igjen senere.",
    "user.EXCLUIR USUÁRIO": "SLETT BRUKER",
    "user.delete.paragrafo 1": "Vil du slette brukeren fra IOK-plattformen?",
    "user.delete.paragrafo 2": "Hvis du gjør dette, mister brukeren tilgang til alle verktøyene på plattformen, med mindre vedkommende legges til igjen ved å følge registreringsinstruksjonene.",
    "user.EDITAR USUÁRIO": "REDIGER BRUKER",
    "user.Usuário editado com sucesso!": "Brukeren ble oppdatert!",
    "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "Kunne ikke redigere denne brukeren. Prøv igjen senere.",
    "user.INFORMAÇÕES DO USUÁRIO": "BRUKERINFORMASJON",
    "user.Telefone": "Telefon",
    "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "Kunne ikke registrere denne brukeren. Prøv igjen senere.",
    "user.Usuário adicionado com sucesso!": "Brukeren ble lagt til!",
    "user.CRIAR TIPO DE USUÁRIO": "OPPRETT BRUKERTYPE",
    "user.Criar novo tipo de usuário": "Opprett ny brukertype",
    "user.Adicionar novo usuário": "Legg til ny bruker",
    "user.Permissões": "Tillatelser",
    "user.Preencha o nome do novo tipo de usuário": "Fyll inn navnet på den nye brukertypen",
    "user.Selecione pelo menos uma permissão": "Velg minst én tillatelse",
    "user.Não foi possível carregar as permissões": "Kunne ikke laste inn tillatelsene",
    "user.Tipo de usuário criado com sucesso!": "Brukertypen ble opprettet!",
    "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "Kunne ikke opprette denne nye brukertypen. Prøv igjen senere.",
    "user.Não foi possível carregar os tipos de usuário da companhia": "Kunne ikke laste inn selskapets brukertyper",
    "user.Tipo de usuário": "Brukertype",
    "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "E-postadressen er allerede registrert på plattformen. Oppgi en ny e-postadresse",
    "user.UNIR CONTAS": "SLÅ SAMMEN KONTOER",
    "user.ID da companhia": "Selskaps-ID",
    "user.Digite o ID da companhia que deseja unir a sua conta": "Oppgi ID-en til selskapet du ønsker å slå sammen med kontoen din",
    "user.Preencha o ID da companhia": "Fyll inn selskaps-ID-en",
    "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "Administratoren for den andre kontoen finner ID-en ved å klikke på brukernavnet sitt i toppmenyen øverst til høyre på skjermen.",
    "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!": "Administratoren for den andre kontoen vil motta en e-post for å godkjenne forespørselen din. Så snart den er godkjent, blir de to kontoene slått sammen!",
    "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "Kunne ikke sende forespørselen om sammenslåing av kontoer. Bekreft ID-en eller prøv igjen senere.",
    "user.SOLICITAÇÃO APROVADA COM SUCESSO": "FORESPØRSEL GODKJENT",
    "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "VENT MENS VI SLÅR SAMMEN KONTOENE. DENNE PROSESSEN KAN TA NOEN MINUTTER...",
    "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "SAMMENSLÅINGEN AV KONTOENE ER FULLFØRT! KLIKK PÅ KNAPPEN NEDENFOR FOR Å FÅ TILGANG TIL PLATTFORMEN.",
    "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.": "VI KUNNE IKKE SLÅ SAMMEN KONTOENE. PRØV IGJEN. HVIS PROBLEMET VEDVARER, KONTAKT VÅR SUPPORT.",
    "user.possui todos os acessos": "har alle tilganger",
    "user.possui o acesso das abas cookbook, meus menus e equipamentos": "har tilgang til fanene Cookbook, Mine menyer og Utstyr",
    "user.possui apenas o acesso da aba cookbook": "har kun tilgang til fanen Cookbook",
    "user.possui apenas o acesso da aba equipamentos": "har kun tilgang til fanen Utstyr",
    "user.possui apenas o acesso da aba meus menus": "har kun tilgang til fanen Mine menyer",
    "user.Grupo de equipamentos": "Utstyrsgruppe",
    "user.Informe o telefone do usuário": "Oppgi brukerens telefonnummer",
    "user.Nenhum grupo criado": "Ingen grupper opprettet",
    "user.Digite o ID da companhia que terá acesso à sua conta": "Oppgi ID-en til selskapet som skal ha tilgang til kontoen din",
    "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.":
    "Når du oppgir en ID for å slå sammen kontoer med selskapet ditt, må du være klar over at den nye brukeren også blir administrator for selskapets konto. Vær også oppmerksom på at fra det øyeblikket en bruker godtar å slå sammen kontoene med selskapet ditt, vil selskapet som tilhører denne brukeren opphøre å eksistere.",
    "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Eksempel: Din konto: 001 | Annen konto: 111. Etter sammenslåingen vil den andre kontoen bli 001.",
    "user.Tela de Equipamentos": "Utstyrsskjerm",
    "user.Tela de Meus Menus": "Skjermen Mine menyer",
    "user.Tela do Cookbook": "Cookbook-skjermen",
    "user.Tela de Usuários": "Brukerskjerm",
    "user.Aba de Suporte": "Supportfane",
    "user.Usuário Comum": "Standardbruker",
    "user.Usuário do Cookbook": "Cookbook-bruker",
    "user.Usuário de Equipamentos": "Utstyrsbruker",
    "user.Usuário de Meus Menus": "Bruker av Mine menyer",
    "user.Você deseja excluir seu acesso da plataforma IOK?": "Vil du slette tilgangen din til IOK-plattformen?",
    "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "Hvis du gjør dette, mister du tilgangen til alle verktøyene på plattformen. For å få tilgang igjen må du legges til på nytt.",
    "user.CONFIRMAÇÃO": "BEKREFTELSE",
    "user.Confirme sua senha": "Bekreft passordet ditt",
    "user.Senha incorreta": "Feil passord",
    "user.Os equipamentos e menus criados por ele serão transferidos para o seu nome.": "Utstyret og menyene som er opprettet av denne brukeren, vil bli overført til ditt navn.",
    
    //TUTORIAIS
    "tutorial.Fechar": "Lukk",
    "tutorial.Fim": "Slutt",
    "tutorial.Próximo": "Neste",
    "tutorial.Abrir": "Åpne",
    "tutorial.Pular tutorial": "Hopp over veiledning",
    "tutorial.Editar detalhes da receita": "Rediger oppskriftsdetaljer",
    "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "Nå kan du legge til flere detaljer i oppskriftene dine og gjøre dem enda mer komplette. Klikk på Rediger detaljer og fyll inn den nødvendige informasjonen.",
    "tutorial.Salvar edição da receita": "Lagre oppskriftsendringer",
    "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "Etter at du har lagt til flere detaljer om oppskriften, klikker du på Lagre.",
    "tutorial.Editar registro de um equipamento": "Rediger registrering av utstyr",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Categoria e Loja.": "For å fullføre registreringen av utstyret ditt, åpner du sidemenyen, klikker på Rediger og fyller inn informasjon om kategori og butikk.",
    "tutorial.Editar usuário": "Rediger bruker",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informasjon referente a Loja a qual ele faz parte.": "For å fullføre registreringen av brukerne åpner du sidemenyen, klikker på Rediger og fyller inn informasjon om hvilken butikk brukeren tilhører.",
    "tutorial.Salvar edições de um equipamento": "Lagre endringer på utstyr",
    "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "Etter at du har fullført registreringen av utstyret ditt, klikker du på Lagre.",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Ved å klikke på raden til et utstyr som er registrert i en butikk, kan du se flere statistikker og opplysninger om det, samt be om service eller sende oppdateringer.",
    "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "For å se mer informasjon om butikken, som plassering og de mest tilberedte oppskriftene, klikker du på raden til enheten du ønsker å analysere.",
    "tutorial.Criar receita": "Opprett oppskrift",
    "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "I Cookbook kan du opprette dine egne oppskrifter! Klikk på Opprett oppskrift og fyll inn all nødvendig informasjon.",
    "tutorial.Editar ou excluir um usuário": "Rediger eller slett en bruker",
    "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "For å slette eller redigere informasjonen til en registrert bruker, åpner du sidemenyen og velger ønsket alternativ.",
    "tutorial.Gerenciamento de usuários": "Brukeradministrasjon",
    "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Her kan du administrere brukerne dine på en enklere måte. Ved å klikke på + Bruker kan du legge til en ny bruker eller opprette en ny brukertype.",
    "tutorial.Suas receitas": "Dine oppskrifter",
    "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do Cookbook da Prática e também as criadas por você.": "I Cookbook finner du også dine egne oppskrifter, og du kan opprette nye! Klikk på Lagrede oppskrifter for å se oppskrifter som er lagret fra Práticas Cookbook, samt oppskriftene du selv har opprettet.",
    "tutorial.Filtros do Cookbook": "Cookbook-filtre",
    "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "For å gjøre det enklere å navigere mellom oppskriftene kan du bruke filtre. Klikk på ønsket filter og velg ett av alternativene.",
    "tutorial.Cookbook": "Cookbook",
    "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "I Cookbook, under Tilgjengelige oppskrifter, finner du oppskrifter laget av Práticas kokker, som du kan bruke når du ønsker.",
    "tutorial.Atualizar equipamentos": "Oppdater utstyr",
    "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.": "For å sende en oppdatering til utstyret ditt klikker du på Oppdater utstyr, velger modellene som skal oppdateres og hvordan oppdateringen skal utføres – via Wi-Fi eller USB-minne. Klikk deretter på Bekreft.",
    "tutorial.Adicionar equipamento": "Legg til utstyr",
    "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "For å legge til et utstyr på kontoen din klikker du på Legg til utstyr og fyller inn informasjonen i dialogvinduet. Klikk deretter på Lagre.",
    "tutorial.Editar equipamento": "Rediger utstyr",
    "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "For å koble fra et utstyr eller redigere informasjonen om det, åpner du sidemenyen og velger ønsket alternativ.",
    "tutorial.Seus equipamentos": "Ditt utstyr",
    "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Her ser du alt utstyr som er registrert på plattformen din.",
    "tutorial.Restaurar arquivos": "Gjenopprett filer",
    "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "For å gjenopprette en slettet fil eller slette den permanent, åpner du sidemenyen og velger ønsket alternativ.",
    "tutorial.Lixeira": "Papirkurv",
    "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "Slettede menyer blir liggende i Papirkurven i 30 dager. Etter denne perioden blir de slettet permanent.",
    "tutorial.Salvar edições de usuário": "Lagre endringer for bruker",
    "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "Når du har fullført registreringen av brukerne, klikker du på Lagre.",
    "tutorial.Criar menu": "Opprett meny",
    "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "For å opprette og tilpasse en meny klikker du på Opprett meny og fyller inn nødvendig informasjon i dialogvinduet. Du kan redigere en meny når som helst.",
    "tutorial.Importar menu": "Importer meny",
    "tutorial.Para importar um menu, clique em Importar Menu e selecione o modell e versão do equipamento.": "For å importere en meny klikker du på Importer meny og velger utstyrsmodell og versjon.",
    "tutorial.Criar grupo": "Opprett gruppe",
    "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "For å organisere oppskriftene dine i grupper klikker du på Opprett gruppe og fyller inn nødvendig informasjon i dialogvinduet.",
    "tutorial.Tipos de usuário": "Brukertyper",
    "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "Nå kan du også opprette brukertyper med spesifikke tillatelser for å dekke organisasjonens behov bedre.",
    "tutorial.Gerenciamento de contas": "Kontoadministrasjon",
    "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "Hvis en annen person i organisasjonen din også har migrert selskapets hovedkonto, kan du slå sammen de to kontoene her.",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "For å fullføre registreringen av utstyret ditt åpner du sidemenyen, klikker på Rediger og fyller inn gruppeinformasjonen.",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "For å fullføre registreringen av brukerne åpner du sidemenyen, klikker på Rediger og fyller inn informasjon om utstyrsgruppen de tilhører.",
    "tutorial.Grupos de equipamentos": "Utstyrsgrupper",
    "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "På fanen Grupper kan du se de registrerte gruppene og utstyret som er fordelt mellom dem. Du kan også opprette nye grupper og redigere eksisterende.",
    "tutorial.Detalhes de grupos": "Gruppedetaljer",
    "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "For å se mer informasjon om gruppen, for eksempel plassering og de mest tilberedte oppskriftene, klikker du på raden du vil analysere.",
    "tutorial.Equipamentos em grupos": "Utstyr i grupper",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Ved å klikke på raden til et utstyr som er registrert i en gruppe, kan du se flere statistikker og opplysninger om det, samt be om service eller sende oppdateringer.",
    "tutorial.Grupos": "Grupper",
    "tutorial.Atualização e cache": "Oppdatering og hurtigbuffer",
    "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "Klikk her for å oppdatere plattformen og løse eventuelle problemer med hurtigbufferen.",
    "tutorial.Dados dos equipamentos": "Utstyrsdata",
    "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "Ved å klikke på raden til et utstyr kan du se flere statistikker og opplysninger om det, som de mest tilberedte oppskriftene, utførte rengjøringer og andre relevante data.",
    "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "For å endre språket på plattformen klikker du på Språk og velger ønsket språk.",
    "tutorial.Alterar idioma": "Endre språk",
    "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "For å redigere eller konfigurere kontoen din klikker du på navnet ditt og velger ønsket alternativ.",
    "tutorial.Editar conta": "Rediger konto",
    "tutorial.Total de Usuários Cadastrados em sua conta.": "Totalt antall registrerte brukere på kontoen din.",
    "tutorial.Home": "Hjem",
    "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Plasseringen til utstyret ditt, med mulighet til å utvide kartet for bedre visning;",
    "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "Oppdateringer knyttet til versjonen av utstyret som er koblet til kontoen din;",
    "tutorial.Total de Receitas Cadastradas;": "Totalt antall registrerte oppskrifter;",
    "tutorial.Menus Disponíveis;": "Tilgjengelige menyer;",
    "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;": "Dette er startsiden din! Her finner du en generell oversikt over kontoen din;",
    "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Klikk på fanene i menyen for å utforske plattformen og bli kjent med alt den har å tilby.",
    "tutorial.Exportar menu": "Eksporter meny",
    "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou por pen drive.": "Etter at du har tilpasset menyen, eksporterer du den til utstyret ditt via Internett eller USB-minne.",
    "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "På fanen Plassering kan du se de registrerte adressene og opprette nøyaktige plasseringer for å knytte utstyret ditt til dem.",
    "tutorial.Localização": "Plassering",
    "tutorial.Informações sobre o equipamento": "Informasjon om utstyret",
    "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;": "Utstyr som er slått på, og hvor mange som sender bruksdata;",
    
    //RECOVER ACCOUNT
    "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "For å fortsette, velg kategorien du tilhører:",
    "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.": "Ønsker du å få tilgang til plattformen som DISTRIBUTØR? Opprett kontoen din ved å klikke på BEDRIFT, og kontakt oss slik at vi kan gi deg tilgang til de øvrige funksjonene.",
    "recoverAccount.A qual organização você pertence": "Hvilken organisasjon tilhører du?",
    
    //RECOVER PASSWORD PAGE
    "recoverPassword.E-mail para recuperação de senha": "E-post for gjenoppretting av passord",
    "recoverPassword.Informe o e-mail cadastrado na plataforma": "Oppgi e-postadressen som er registrert på plattformen",
    "recoverPassword.E-mail inválido. Por favor, verifique": "Ugyldig e-postadresse. Vennligst kontroller.",
    "recoverPassword.RECUPERAR SENHA": "GJENOPPRETT PASSORD",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA": "DU VIL SNART MOTTA EN E-POST MED LENKEN FOR GJENOPPRETTING AV PASSORD",
    "recoverPassword.Informe seu e-mail": "Oppgi e-postadressen din",
    "recoverPassword.Crie uma nova senha": "Opprett et nytt passord",
    "recoverPassword.O campo senha deve conter no mínimo 6 caracteres": "Passordfeltet må inneholde minst 6 tegn",
    "recoverPassword.Confirme sua senha": "Bekreft passordet ditt",
    "recoverPassword.As senhas devem ser iguais": "Passordene må være identiske",
    "recoverPassword.ENTRAR": "LOGG INN",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "DU VIL SNART MOTTA EN E-POST FOR Å BEKREFTE IDENTITETEN DIN",
    "recoverPassword.CONTINUAR": "FORTSETT",
    "recoverPassword.CONFIRMAR": "BEKREFT",
    "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "Av sikkerhetsgrunner er tilgangen til kontoen blokkert på grunn av flere mislykkede innloggingsforsøk.",
    "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "For å låse opp kontoen din, følg instruksjonene etter å ha klikket på knappen nedenfor:",
    "recoverPassword.Desbloquear conta": "Lås opp konto",
    "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "Du har mottatt en e-post for å starte opplåsingen av kontoen din.",
    "recoverPassword.Verifique sua caixa de entrada ou spam.": "Sjekk innboksen eller søppelpostmappen din.",
    "recoverPassword.Verifique seu e-mail": "Sjekk e-posten din",
    "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "Oppgi innloggingsadressen din og opprett et nytt passord for å få tilgang til kontoen din.",
    
    
    
    
    
    
    // EXPORT
    "export.Limpezas": "Rengjøringer",
    "export.Eventos": "Hendelser",
    "export.Lista de receitas preparadas": "Liste over utførte oppskrifter",
    "export.Lista de limpezas realizadas": "Liste over utførte rengjøringer",
    "export.Lista de eventos ocorridos": "Liste over registrerte hendelser",
    "export.Exportar dados": "Eksporter data",
    "export.Exportar": "Eksporter",
    "export.Informações do equipamento": "Utstyrsinformasjon",
    "export.Dados exportados com sucesso!": "Data ble eksportert!",
    "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "Kunne ikke eksportere dataene. Prøv igjen senere.",
    "export.Detalhes do menu": "Menydetaljer",
    "export.Detalhes de receitas": "Oppskriftsdetaljer",
    "export.Detalhes e Passos": "Detaljer og trinn",
    "export.Exportando dados. Em breve o arquivo estará disponível!": "Eksporterer data. Filen vil snart være tilgjengelig!",
    "export.Resumo dos passos": "Sammendrag av trinn",
    "export.salvar imagem": "lagre bilde",
    "export.Nenhum modelo foi selecionado": "Ingen modell er valgt",
    
    // COMPANIES PAGE
    "company.Procurar companhia": "Søk etter selskap",
    "company.Adicionar companhia": "Legg til selskap",
    "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "DET ER ENNÅ INGEN REGISTRERTE SELSKAPER :(",
    "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Klikk på knappen øverst til høyre for å legge til selskaper.",
    "company.Adicionar": "Legg til",
    "company.ADICIONAR EQUIPAMENTOS": "LEGG TIL UTSTYR",
    "company.Preencha pelo menos um número de série": "Fyll inn minst ett serienummer",
    "company.Informe os números de série": "Oppgi serienumrene",
    "company.Número de série": "Serienummer",
    "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "For å legge til flere enheter, skill dem med semikolon (;).",
    "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Oppgi serienummeret til utstyret du vil legge til nedenfor.",
    "company.Números de série adicionados com sucesso!": "Serienumrene ble lagt til!",
    "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "Kunne ikke legge til serienumrene. Prøv igjen senere.",
    "company.adicionar": "legg til",
    "company.Procurar por companhia ou ID": "Søk etter selskap eller ID",
    "company.Companhia": "Selskap",
    "company.E-mail principal": "Primær e-post",
    "company.Local": "Sted",
    "company.Companhia adicionada com sucesso!": "Selskapet ble lagt til!",
    "company.Não foi possível cadastrar a companhia": "Kunne ikke registrere selskapet",
    "company.REMOVER COMPANHIA": "FJERN SELSKAP",
    "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "Vil du fjerne selskapet permanent? Utstyret som er knyttet til det, vil også bli fjernet fra kontoen din.",
    "company.Esta ação não poderá ser desfeita.": "Denne handlingen kan ikke angres.",
    "company.A companhia foi removida com sucesso!": "Selskapet ble fjernet!",
    "company.Não foi possível remover a companhia": "Kunne ikke fjerne selskapet",
    "company.Quant. de fornos": "Antall ovner",
    "company.Fornos conectados": "Tilkoblede ovner",
    "company.Fornos não conectados": "Ikke-tilkoblede ovner",
    "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "DET ER ENNÅ INGEN REGISTRERTE ENHETER :(",
    "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Klikk på knappen øverst til høyre for å legge til utstyr.",
    "company.Procurar número de série": "Søk etter serienummer",
    "company.excluir equipamento": "fjern utstyr",
    "company.Você deseja excluir o equipamento selecionado definitivamente?": "Vil du slette det valgte utstyret permanent?",
    "company.Número de série editado com sucesso!": "Serienummeret ble oppdatert!",
    "company.Não foi possível editar o número de série. Tente novamente mais tarde": "Kunne ikke oppdatere serienummeret. Prøv igjen senere.",
    "company.Informe o número de série": "Oppgi serienummeret",
    "company.Preencha um número de série": "Fyll inn et serienummer",
    "company.EDITAR EQUIPAMENTO": "REDIGER UTSTYR",
    "company.Modelo": "Modell",
    "company.Cadastro": "Registrering",
    "company.Conectado": "Tilkoblet",
    "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "VELG UTSTYR SOM SKAL SLETTES",
    "company.O equipamento foi removida com sucesso!": "Utstyret ble fjernet!",
    "company.Não foi possível remover o equipamento": "Kunne ikke fjerne utstyret",
    "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "Spesialtegn er ikke tillatt, bortsett fra semikolon (';').",
    "company.Preencha o número de série sem caracteres especiais": "Fyll inn serienummeret uten spesialtegn",
    "company.Um ou mais números de série já estão provisionados para outra companhia": "Ett eller flere serienumre er allerede tildelt et annet selskap.",
    "company.Um ou mais números de série já estão conectados na conta de outra companhia": "Ett eller flere serienumre er allerede koblet til kontoen til et annet selskap.",
    
    // Error
    "error.Ocorreu um erro ao carregar esta seção": "Det oppstod en feil under innlasting av denne delen",
    "error.Tentar novamente": "Prøv igjen",
    
    //DASHBOARDS
    "dashboard.fornos vinculados": "TILKNYTTEDE OVNER",
    "dashboard.ativos": "Aktive",
    "dashboard.inativos": "Inaktive",
    "dashboard.sem status": "Ingen status",
    "dashboard.fornos atualizados": "OPPDATERTE OVNER",
    "dashboard.com a versão do software mais recente": "Med den nyeste programvareversjonen",
    "dashboard.chamados": "SERVICEHENVENDELSER",
    "dashboard.veja mais no app cliente": "Se mer i kundeappen",
    "dashboard.limpeza diária": "DAGLIG RENGJØRING",
    "dashboard.dos fornos estão em dia": "av ovnene er oppdaterte",
    "dashboard.top 3": "Topp 3",
    "dashboard.média de execuções de receitas por hora": "Gjennomsnittlig antall oppskriftstilberedninger per time",
    "dashboard.avisos": "VARSLER",
    "dashboard.sem avisos por aqui": "INGEN VARSLER HER",
    "dashboard.ver mais": "Se mer",
    "dashboard.abertos pela plataforma IOK": "Opprettet av IOK-plattformen",
    "dashboard.equipamentos": "Utstyr",
    "dashboard.receitas": "Oppskrifter",
    "dashboard.executada": "tilberedt",
    "dashboard.vezes": "ganger",
    "dashboard.forno": "Ovn",
    "dashboard.média por hora": "Gjennomsnitt per time",
    "dashboard.editar": "rediger",
    "dashboard.endereço:": "Adresse:",
    "dashboard.cep:": "Postnummer:",
    "dashboard.estatísticas": "Statistikk",
    "dashboard.uso de equipamento": "Utstyrsbruk",
    "dashboard.pico de uso": "Topplast",
    "dashboard.receitas mais executadas por equipamento": "Mest tilberedte oppskrifter per utstyr",
    "dashboard.recolher": "skjul",
    "dashboard.TOROS TC CONECTADOS:": "TILKOBLEDE TOROS TC:",
    "dashboard.Consumo de energia - Lastro Toro TC": "Energiforbruk – Lastro Toro TC",
    "dashboard.tootilp": "Summen av alle oppskrifter som er tilberedt i løpet av den aktuelle dagen, delt på antall timer ovnen har vært slått på.",
    "dashboard.noResults": "Ingen resultater funnet :(",
    "dashboard.Preaquecimento": "Forvarming",
    "dashboard.Esfriamento": "Avkjøling",
    "dashboard.Execução de receitas": "Tilberedning av oppskrifter",
    "dashboard.Execução de receitas TSi": "TSi-oppskriftstilberedning",
    "dashboard.Modo manual": "Manuell modus",
    "dashboard.Limpeza": "Rengjøring",
    "dashboard.Porta": "Dør",
    "dashboard.Erros e alertas": "Feil og varsler",
    "dashboard.Parâmetros": "Parametere",
    "dashboard.SEM DADOS POR AQUI": "INGEN DATA HER",
    "dashboard.AINDA SEM GRÁFICOS POR AQUI": "INGEN GRAFER HER ENNÅ",
    "dashboard.description.AINDA SEM GRÁFICOS POR AQUI": "Velg elementer fra listen ved siden av for å generere grafer, eller klikk på raden for å se flere detaljer.",
    
    
    //INFORMAÇÕES IOK
    "iokInformation.search.placeholder": "Søk etter artikkel",
    "iokInformation.article.openInHelpCenter": "Se artikkelen i hjelpesenteret",
    "iokInformation.aboutPlatform.platformFeatures.title": "Plattformen og dens funksjoner",
    "iokInformation.aboutPlatform.platformFeatures.linkLabel": "Last ned fullstendig presentasjon",
    "iokInformation.aboutPlatform.manual.title": "Brukerhåndbok",
    "iokInformation.aboutPlatform.manual.linkLabel": "Last ned håndbok",
    "iokInformation.aboutPlatform.privacy.title": "Personvernerklæring",
    "iokInformation.aboutPlatform.privacy.linkLabel": "Last ned personvernerklæring",
    "iokInformation.aboutPlatform.api.title": "Ekstern API",
    "iokInformation.aboutPlatform.api.linkLabel": "Last ned dokument",
    
    //Telemetry TSI
    "telemetry.EQUIPMENT_TURN_ON": "Utstyr slått på",
    "telemetry.SENSORS_VALUES": "Sensorverdier",
    "telemetry.ERROR_DETECTED": "Feil oppdaget",
    "telemetry.TIME_ADDED": "Tid lagt til",
    "telemetry.GN_ADDED": "GN lagt til",
    "telemetry.GN_RELEASED": "GN startet",
    "telemetry.GN_FINISHED": "GN fullført",
    
    "telemetry.HEAVY_CLEANING_CANCELED": "Kraftig rengjøring avbrutt",
    "telemetry.CLEANING_CANCELED": "Rengjøring avbrutt",
    "telemetry.CLEANING_RESTARTED": "Rengjøring startet på nytt",
    "telemetry.CLEANING_VAPORIZATION_STEP": "Fordampningstrinn i rengjøringen",
    "telemetry.CLEANING_SUPPLY_STEP": "Påfyllingstrinn i rengjøringen",
    "telemetry.CLEANING_CIRCULATION_STEP": "Sirkulasjonstrinn i rengjøringen",
    "telemetry.CLEANING_DEPLETION_STEP": "Tømmingstrinn i rengjøringen",
    "telemetry.CLEANING_RISING_STEP": "Skyllingstrinn i rengjøringen",
    "telemetry.CLEANING_STARTED": "Rengjøring startet",
    "telemetry.CLEANING_FINISHED": "Rengjøring fullført",
    "telemetry.RECOMMENDED_CLEANING": "Anbefalt rengjøring",
    "telemetry.VALID_PASSWORD_CLEANING": "Gyldig passord ved rengjøring",
    "telemetry.INVALID_PASSWORD_CLEANING": "Ugyldig passord ved rengjøring",
    
    "telemetry.RECIPE_STARTED": "Oppskrift startet",
    "telemetry.RECIPE_FINISHED": "Oppskrift fullført",
    "telemetry.RECIPE_CANCELED": "Oppskrift avbrutt",
    "telemetry.RECIPE_STEP_CHANGED": "Oppskriftstrinn endret",
    "telemetry.RECIPE_PAUSED": "Oppskrift satt på pause",
    "telemetry.RECIPE_RESUMED": "Oppskrift gjenopptatt",
    "telemetry.DROP_ENERGY_SUPPLY": "Gjenopptatt etter strømbrudd",
    "telemetry.RESUME_RECIPE_CANCELED": "Gjenopptakelse av oppskrift avbrutt",
    
    "telemetry.PRE_HEAT_STARTED": "Forvarming startet",
    "telemetry.PRE_HEAT_FINISHED": "Forvarming fullført",
    "telemetry.OPERATION_CONTINUE_STARTED": "Gjenopptakelse av drift startet",
    "telemetry.OPERATION_CONTINUE_FINISHED": "Gjenopptakelse av drift fullført",
    "telemetry.HOLD_TEMPERATURE_STARTED": "Temperaturhold startet",
    "telemetry.HOLD_TEMPERATURE_FINISHED": "Temperaturhold fullført",
    "telemetry.COOL_DOWN_STARTED": "Avkjøling startet",
    "telemetry.COOL_DOWN_FINISHED": "Avkjøling fullført",
    "telemetry.NOCTURNAL_COOKING_STARTED": "Nattsteking startet",
    "telemetry.NOCTURNAL_COOKING_FINISHED": "Nattsteking fullført",
    "telemetry.SEALING_STARTED": "Forsegling startet",
    "telemetry.SEALING_FINISHED": "Forsegling fullført",
    "telemetry.TURBO_GRILL_STARTED": "Turbo Grill startet",
    "telemetry.TURBO_GRILL_FINISHED": "Turbo Grill fullført",
    "telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill aktivert",
    "telemetry.TURBO_GRILL_DISABLED": "Turbo Grill deaktivert",
    
    "telemetry.MOISTURE_CHANGED": "Fuktighet endret",
    "telemetry.TURBINE_CHANGED": "Viftehastighet endret",
    "telemetry.SET_POINT_CHANGED": "Kammertemperatur endret",
    "telemetry.STEAM_CHANGED": "Damp endret",
    "telemetry.PROBE_CHANGED": "Sondetemperatur endret",
    "telemetry.TIME_CHANGED": "Tid endret",
    "telemetry.DOOR_OPENED": "Dør åpnet",
    "telemetry.DOOR_CLOSED": "Dør lukket",
    
    "telemetry.PROBE_CONTROL_SELECTED": "Sondekontroll valgt",
    "telemetry.TIME_CONTROL_SELECTED": "Tidskontroll valgt",
    "telemetry.MANUAL_STEAM_INJECTED": "Manuell dampinjeksjon",
    "telemetry.AUTOMATIC_STEAM_INJECTED": "Automatisk dampinjeksjon",
    
    "telemetry.DATABASE_CREATED": "Database opprettet",
    "telemetry.EXIT_FUNCTION": "Funksjon avsluttet",
    "telemetry.CONSUMPTION": "Forbruk",
    "telemetry.STANDBY": "Standby",
    
    "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Analytics-feil: Ugyldig forespørsel",
    "telemetry.ANALYTICS_ERROR_FORBIDDEN": "Analytics-feil: Tilgang nektet",
    "telemetry.ANALYTICS_ERROR_SERVER": "Analytics-feil: Serverfeil",
    "telemetry.ANALYTICS_ERROR_UNEXPECTED": "Analytics-feil: Uventet feil",
    "telemetry.ANALYTICS_SUCCESS": "Analytics vellykket",
    
    "telemetry.STEP": "Trinn",
    "telemetry.STEAM": "Damp",
    "telemetry.PROBE": "Sonde",
    "telemetry.TURBINE": "Vifte",
    "telemetry.OCCURRENCES": "forekomst(er)",
    "telemetry.FUNC_USER_RECIPE": "Brukeroppskrift",
    "telemetry.FUNC_TSI_RECIPE": "TSi-oppskrift",
    "telemetry.FUNC_DELTA_T": "Delta T",
    "telemetry.FUNC_STEAM": "Damp",
    "telemetry.FUNC_COMBINED_STEAM": "Kombinert damp",
    "telemetry.FUNC_HOT_AIR": "Varmluft",
    "telemetry.FUNC_NOCTURNAL_COOKING": "Nattsteking",
    "telemetry.FUNC_REGENERATE": "Regenerering",
    "telemetry.FUNC_MULTIPLE_COOKING": "Flernivåsteking",
    
    "haccp.filterBy": "Filtrer etter",
    "haccp.export.generating": "HACCP-regnearket blir generert og vil bli lastet ned automatisk om kort tid.",
    "haccp.voltage": "Spenning",
    "haccp.voltageReading": "Spenningsmåling",
    "haccp.voltageOscillation": "Spenningssvingninger i løpet av dagen",
    "haccp.status.normal": "Normal",
    "haccp.status.attention": "Advarsel",
    "haccp.status.critical": "Kritisk",
    "haccp.dateTime": "Dato/klokkeslett",
    "haccp.errorDetected": "Feil/varsel oppdaget",
    "haccp.detected": "oppdaget",
    "haccp.errorTypeLabel": "Type feil/varsel",
    "haccp.severityLabel": "Alvorlighetsgrad",
    "haccp.severity.error": "Feil",
    "haccp.severity.alert": "Advarsel",
    "haccp.error.canNetwork": "CAN-nettverksfeil",
    "haccp.error.chamberSensor": "Kammersensorfeil",
    "haccp.error.steamSensor": "Dampsensorfeil",
    "haccp.error.probeSensor": "Sondefeil",
    "haccp.error.noWater": "Feil: mangel på vann",
    "haccp.error.panelTemp": "Feil: paneltemperatur",
    "haccp.error.motor": "Motorfeil",
    "haccp.error.motorComm": "Kommunikasjonsfeil med motor",
    "haccp.error.hygieneIncomplete": "Feil: ufullstendig rengjøring",
    "haccp.error.familyModel": "Feil: produktfamilie/modell",
    "haccp.error.boardTemp": "Feil: kretskorttemperatur",
    "haccp.error.energyModule": "Feil: energimodul",
    "haccp.error.i2c": "I2C-feil",
    "haccp.error.gas": "Gassfeil",
    "haccp.loading": "Laster...",
    "haccp.quantity": "Antall",
    "haccp.executions": "Tilberedninger",
    "haccp.manual.mode": "Modus",
    "haccp.manual.tempC": "Temp (°C)",
    "haccp.manual.timeMin": "Tid (min)",
    "haccp.manual.probeC": "Sonde (°C)",
    "haccp.manual.steamPct": "Damp %",
    "haccp.cleaning.label": "Rengjøring",
    "haccp.cleaning.recommendedLabel": "Anbefalt rengjøring",
    "haccp.cleaning.status.completed": "Fullført",
    "haccp.cleaning.status.restarted": "Startet på nytt",
    "haccp.cleaning.status.interrupted": "Avbrutt",
    "haccp.status.label": "Status",
    "haccp.error": "Feil",
    "haccp.consumption.water": "Vannforbruk",
    "haccp.consumption.energy": "Energiforbruk",
    "haccp.short.temp": "Temp.",
    "haccp.short.time": "Tid",
    "haccp.day": "Dag",
    "haccp.recipeExecutions": "Antall tilberedninger",
    "STEAM": "Damp",
    "COMBINED_STEAM": "Kombinert damp",
    "PROBE": "Sonde",
    "TURBINE": "Vifte",
    "HOT_AIR": "Varm luft",
    "NOCTURNAL_COOKING": "Nattilberedning",
    "REGENERATE": "Regenerering",
    "MULTIPLE_COOKING": "Flernivåtilberedning",
    "DELTA_T": "Delta T",
    
    //CSAT
    "csat.AVALIE SUA EXPERIÊNCIA": "VURDER OPPLEVELSEN DIN",
    "csat.Como você avalia sua experiência com": "Hvordan vurderer du opplevelsen din med",
    "csat.Muito insatisfeito": "Svært misfornøyd",
    "csat.Insatisfeito": "Misfornøyd",
    "csat.Neutro": "Nøytral",
    "csat.Satisfeito": "Fornøyd",
    "csat.Muito satisfeito": "Svært fornøyd",
    "csat.Utilize o espaço abaixo para deixar suas sugestões:": "Bruk feltet nedenfor til å legge igjen forslagene dine:",
    "csat.Digite aqui": "Skriv her",
    "csat.Obrigado por responder à nossa pesquisa!": "Takk for at du besvarte undersøkelsen vår!",
    "csat.Selecione uma nota para continuar": "Velg en vurdering for å fortsette",
    "csat.Enviar": "Send",
    "csat.a criação de receitas": "opprettelse av oppskrifter",
    "csat.o cadastro de equipamentos": "registrering av utstyr",
    "csat.o cadastro de usuários": "registrering av brukere",
    "csat.a criação de menus": "opprettelse av menyer",
    "csat.a deleção de receitas": "sletting av oppskrifter",
    "csat.a reordenação de receitas": "omorganisering av oppskrifter",
    "csat.o envio de software": "utsending av programvare",
    "csat.o envio de menus": "utsending av menyer",
    "csat.o uso de receitas do Cookbook": "bruk av oppskrifter fra Cookbook",
    
  },
};

export default no;


